import { AsyncRule as Nn, RuleType as he, SyncRule as nr, SequenceType as st } from "./Rule.js";
import { g as Rn, p as xt, c as Rs, r as ks } from "./errors-CoLhPo2G.js";
import { z as Zr } from "./zxcvbn-CmVpwea7.js";
import { v as Os, B as js, a as Ts, C as Is, L as Cs } from "./CharRule-CMjLCJA6.js";
import { F as As, R as Ms } from "./RemotePolicyLoader-BTdbyn0r.js";
import Fs from "crypto";
var Bt = { exports: {} }, kn = {}, fe = {}, qe = {}, tt = {}, H = {}, et = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.regexpCode = e.getEsmExportName = e.getProperty = e.safeStringify = e.stringify = e.strConcat = e.addCodeArg = e.str = e._ = e.nil = e._Code = e.Name = e.IDENTIFIER = e._CodeOrName = void 0;
  class t {
  }
  e._CodeOrName = t, e.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
  class r extends t {
    constructor(_) {
      if (super(), !e.IDENTIFIER.test(_))
        throw new Error("CodeGen: name must be a valid identifier");
      this.str = _;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      return !1;
    }
    get names() {
      return { [this.str]: 1 };
    }
  }
  e.Name = r;
  class n extends t {
    constructor(_) {
      super(), this._items = typeof _ == "string" ? [_] : _;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      if (this._items.length > 1)
        return !1;
      const _ = this._items[0];
      return _ === "" || _ === '""';
    }
    get str() {
      var _;
      return (_ = this._str) !== null && _ !== void 0 ? _ : this._str = this._items.reduce((I, M) => `${I}${M}`, "");
    }
    get names() {
      var _;
      return (_ = this._names) !== null && _ !== void 0 ? _ : this._names = this._items.reduce((I, M) => (M instanceof r && (I[M.str] = (I[M.str] || 0) + 1), I), {});
    }
  }
  e._Code = n, e.nil = new n("");
  function s(f, ..._) {
    const I = [f[0]];
    let M = 0;
    for (; M < _.length; )
      u(I, _[M]), I.push(f[++M]);
    return new n(I);
  }
  e._ = s;
  const a = new n("+");
  function i(f, ..._) {
    const I = [w(f[0])];
    let M = 0;
    for (; M < _.length; )
      I.push(a), u(I, _[M]), I.push(a, w(f[++M]));
    return d(I), new n(I);
  }
  e.str = i;
  function u(f, _) {
    _ instanceof n ? f.push(..._._items) : _ instanceof r ? f.push(_) : f.push(p(_));
  }
  e.addCodeArg = u;
  function d(f) {
    let _ = 1;
    for (; _ < f.length - 1; ) {
      if (f[_] === a) {
        const I = c(f[_ - 1], f[_ + 1]);
        if (I !== void 0) {
          f.splice(_ - 1, 3, I);
          continue;
        }
        f[_++] = "+";
      }
      _++;
    }
  }
  function c(f, _) {
    if (_ === '""')
      return f;
    if (f === '""')
      return _;
    if (typeof f == "string")
      return _ instanceof r || f[f.length - 1] !== '"' ? void 0 : typeof _ != "string" ? `${f.slice(0, -1)}${_}"` : _[0] === '"' ? f.slice(0, -1) + _.slice(1) : void 0;
    if (typeof _ == "string" && _[0] === '"' && !(f instanceof r))
      return `"${f}${_.slice(1)}`;
  }
  function h(f, _) {
    return _.emptyStr() ? f : f.emptyStr() ? _ : i`${f}${_}`;
  }
  e.strConcat = h;
  function p(f) {
    return typeof f == "number" || typeof f == "boolean" || f === null ? f : w(Array.isArray(f) ? f.join(",") : f);
  }
  function N(f) {
    return new n(w(f));
  }
  e.stringify = N;
  function w(f) {
    return JSON.stringify(f).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  }
  e.safeStringify = w;
  function v(f) {
    return typeof f == "string" && e.IDENTIFIER.test(f) ? new n(`.${f}`) : s`[${f}]`;
  }
  e.getProperty = v;
  function b(f) {
    if (typeof f == "string" && e.IDENTIFIER.test(f))
      return new n(`${f}`);
    throw new Error(`CodeGen: invalid export name: ${f}, use explicit $id name mapping`);
  }
  e.getEsmExportName = b;
  function $(f) {
    return new n(f.toString());
  }
  e.regexpCode = $;
})(et);
var Wt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueScope = e.ValueScopeName = e.Scope = e.varKinds = e.UsedValueState = void 0;
  const t = et;
  class r extends Error {
    constructor(c) {
      super(`CodeGen: "code" for ${c} not defined`), this.value = c.value;
    }
  }
  var n;
  (function(d) {
    d[d.Started = 0] = "Started", d[d.Completed = 1] = "Completed";
  })(n || (e.UsedValueState = n = {})), e.varKinds = {
    const: new t.Name("const"),
    let: new t.Name("let"),
    var: new t.Name("var")
  };
  class s {
    constructor({ prefixes: c, parent: h } = {}) {
      this._names = {}, this._prefixes = c, this._parent = h;
    }
    toName(c) {
      return c instanceof t.Name ? c : this.name(c);
    }
    name(c) {
      return new t.Name(this._newName(c));
    }
    _newName(c) {
      const h = this._names[c] || this._nameGroup(c);
      return `${c}${h.index++}`;
    }
    _nameGroup(c) {
      var h, p;
      if (!((p = (h = this._parent) === null || h === void 0 ? void 0 : h._prefixes) === null || p === void 0) && p.has(c) || this._prefixes && !this._prefixes.has(c))
        throw new Error(`CodeGen: prefix "${c}" is not allowed in this scope`);
      return this._names[c] = { prefix: c, index: 0 };
    }
  }
  e.Scope = s;
  class a extends t.Name {
    constructor(c, h) {
      super(h), this.prefix = c;
    }
    setValue(c, { property: h, itemIndex: p }) {
      this.value = c, this.scopePath = (0, t._)`.${new t.Name(h)}[${p}]`;
    }
  }
  e.ValueScopeName = a;
  const i = (0, t._)`\n`;
  class u extends s {
    constructor(c) {
      super(c), this._values = {}, this._scope = c.scope, this.opts = { ...c, _n: c.lines ? i : t.nil };
    }
    get() {
      return this._scope;
    }
    name(c) {
      return new a(c, this._newName(c));
    }
    value(c, h) {
      var p;
      if (h.ref === void 0)
        throw new Error("CodeGen: ref must be passed in value");
      const N = this.toName(c), { prefix: w } = N, v = (p = h.key) !== null && p !== void 0 ? p : h.ref;
      let b = this._values[w];
      if (b) {
        const _ = b.get(v);
        if (_)
          return _;
      } else
        b = this._values[w] = /* @__PURE__ */ new Map();
      b.set(v, N);
      const $ = this._scope[w] || (this._scope[w] = []), f = $.length;
      return $[f] = h.ref, N.setValue(h, { property: w, itemIndex: f }), N;
    }
    getValue(c, h) {
      const p = this._values[c];
      if (p)
        return p.get(h);
    }
    scopeRefs(c, h = this._values) {
      return this._reduceValues(h, (p) => {
        if (p.scopePath === void 0)
          throw new Error(`CodeGen: name "${p}" has no value`);
        return (0, t._)`${c}${p.scopePath}`;
      });
    }
    scopeCode(c = this._values, h, p) {
      return this._reduceValues(c, (N) => {
        if (N.value === void 0)
          throw new Error(`CodeGen: name "${N}" has no value`);
        return N.value.code;
      }, h, p);
    }
    _reduceValues(c, h, p = {}, N) {
      let w = t.nil;
      for (const v in c) {
        const b = c[v];
        if (!b)
          continue;
        const $ = p[v] = p[v] || /* @__PURE__ */ new Map();
        b.forEach((f) => {
          if ($.has(f))
            return;
          $.set(f, n.Started);
          let _ = h(f);
          if (_) {
            const I = this.opts.es5 ? e.varKinds.var : e.varKinds.const;
            w = (0, t._)`${w}${I} ${f} = ${_};${this.opts._n}`;
          } else if (_ = N?.(f))
            w = (0, t._)`${w}${_}${this.opts._n}`;
          else
            throw new r(f);
          $.set(f, n.Completed);
        });
      }
      return w;
    }
  }
  e.ValueScope = u;
})(Wt);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.or = e.and = e.not = e.CodeGen = e.operators = e.varKinds = e.ValueScopeName = e.ValueScope = e.Scope = e.Name = e.regexpCode = e.stringify = e.getProperty = e.nil = e.strConcat = e.str = e._ = void 0;
  const t = et, r = Wt;
  var n = et;
  Object.defineProperty(e, "_", { enumerable: !0, get: function() {
    return n._;
  } }), Object.defineProperty(e, "str", { enumerable: !0, get: function() {
    return n.str;
  } }), Object.defineProperty(e, "strConcat", { enumerable: !0, get: function() {
    return n.strConcat;
  } }), Object.defineProperty(e, "nil", { enumerable: !0, get: function() {
    return n.nil;
  } }), Object.defineProperty(e, "getProperty", { enumerable: !0, get: function() {
    return n.getProperty;
  } }), Object.defineProperty(e, "stringify", { enumerable: !0, get: function() {
    return n.stringify;
  } }), Object.defineProperty(e, "regexpCode", { enumerable: !0, get: function() {
    return n.regexpCode;
  } }), Object.defineProperty(e, "Name", { enumerable: !0, get: function() {
    return n.Name;
  } });
  var s = Wt;
  Object.defineProperty(e, "Scope", { enumerable: !0, get: function() {
    return s.Scope;
  } }), Object.defineProperty(e, "ValueScope", { enumerable: !0, get: function() {
    return s.ValueScope;
  } }), Object.defineProperty(e, "ValueScopeName", { enumerable: !0, get: function() {
    return s.ValueScopeName;
  } }), Object.defineProperty(e, "varKinds", { enumerable: !0, get: function() {
    return s.varKinds;
  } }), e.operators = {
    GT: new t._Code(">"),
    GTE: new t._Code(">="),
    LT: new t._Code("<"),
    LTE: new t._Code("<="),
    EQ: new t._Code("==="),
    NEQ: new t._Code("!=="),
    NOT: new t._Code("!"),
    OR: new t._Code("||"),
    AND: new t._Code("&&"),
    ADD: new t._Code("+")
  };
  class a {
    optimizeNodes() {
      return this;
    }
    optimizeNames(o, l) {
      return this;
    }
  }
  class i extends a {
    constructor(o, l, E) {
      super(), this.varKind = o, this.name = l, this.rhs = E;
    }
    render({ es5: o, _n: l }) {
      const E = o ? r.varKinds.var : this.varKind, q = this.rhs === void 0 ? "" : ` = ${this.rhs}`;
      return `${E} ${this.name}${q};` + l;
    }
    optimizeNames(o, l) {
      if (o[this.name.str])
        return this.rhs && (this.rhs = R(this.rhs, o, l)), this;
    }
    get names() {
      return this.rhs instanceof t._CodeOrName ? this.rhs.names : {};
    }
  }
  class u extends a {
    constructor(o, l, E) {
      super(), this.lhs = o, this.rhs = l, this.sideEffects = E;
    }
    render({ _n: o }) {
      return `${this.lhs} = ${this.rhs};` + o;
    }
    optimizeNames(o, l) {
      if (!(this.lhs instanceof t.Name && !o[this.lhs.str] && !this.sideEffects))
        return this.rhs = R(this.rhs, o, l), this;
    }
    get names() {
      const o = this.lhs instanceof t.Name ? {} : { ...this.lhs.names };
      return T(o, this.rhs);
    }
  }
  class d extends u {
    constructor(o, l, E, q) {
      super(o, E, q), this.op = l;
    }
    render({ _n: o }) {
      return `${this.lhs} ${this.op}= ${this.rhs};` + o;
    }
  }
  class c extends a {
    constructor(o) {
      super(), this.label = o, this.names = {};
    }
    render({ _n: o }) {
      return `${this.label}:` + o;
    }
  }
  class h extends a {
    constructor(o) {
      super(), this.label = o, this.names = {};
    }
    render({ _n: o }) {
      return `break${this.label ? ` ${this.label}` : ""};` + o;
    }
  }
  class p extends a {
    constructor(o) {
      super(), this.error = o;
    }
    render({ _n: o }) {
      return `throw ${this.error};` + o;
    }
    get names() {
      return this.error.names;
    }
  }
  class N extends a {
    constructor(o) {
      super(), this.code = o;
    }
    render({ _n: o }) {
      return `${this.code};` + o;
    }
    optimizeNodes() {
      return `${this.code}` ? this : void 0;
    }
    optimizeNames(o, l) {
      return this.code = R(this.code, o, l), this;
    }
    get names() {
      return this.code instanceof t._CodeOrName ? this.code.names : {};
    }
  }
  class w extends a {
    constructor(o = []) {
      super(), this.nodes = o;
    }
    render(o) {
      return this.nodes.reduce((l, E) => l + E.render(o), "");
    }
    optimizeNodes() {
      const { nodes: o } = this;
      let l = o.length;
      for (; l--; ) {
        const E = o[l].optimizeNodes();
        Array.isArray(E) ? o.splice(l, 1, ...E) : E ? o[l] = E : o.splice(l, 1);
      }
      return o.length > 0 ? this : void 0;
    }
    optimizeNames(o, l) {
      const { nodes: E } = this;
      let q = E.length;
      for (; q--; ) {
        const z = E[q];
        z.optimizeNames(o, l) || (D(o, z.names), E.splice(q, 1));
      }
      return E.length > 0 ? this : void 0;
    }
    get names() {
      return this.nodes.reduce((o, l) => P(o, l.names), {});
    }
  }
  class v extends w {
    render(o) {
      return "{" + o._n + super.render(o) + "}" + o._n;
    }
  }
  class b extends w {
  }
  class $ extends v {
  }
  $.kind = "else";
  class f extends v {
    constructor(o, l) {
      super(l), this.condition = o;
    }
    render(o) {
      let l = `if(${this.condition})` + super.render(o);
      return this.else && (l += "else " + this.else.render(o)), l;
    }
    optimizeNodes() {
      super.optimizeNodes();
      const o = this.condition;
      if (o === !0)
        return this.nodes;
      let l = this.else;
      if (l) {
        const E = l.optimizeNodes();
        l = this.else = Array.isArray(E) ? new $(E) : E;
      }
      if (l)
        return o === !1 ? l instanceof f ? l : l.nodes : this.nodes.length ? this : new f(O(o), l instanceof f ? [l] : l.nodes);
      if (!(o === !1 || !this.nodes.length))
        return this;
    }
    optimizeNames(o, l) {
      var E;
      if (this.else = (E = this.else) === null || E === void 0 ? void 0 : E.optimizeNames(o, l), !!(super.optimizeNames(o, l) || this.else))
        return this.condition = R(this.condition, o, l), this;
    }
    get names() {
      const o = super.names;
      return T(o, this.condition), this.else && P(o, this.else.names), o;
    }
  }
  f.kind = "if";
  class _ extends v {
  }
  _.kind = "for";
  class I extends _ {
    constructor(o) {
      super(), this.iteration = o;
    }
    render(o) {
      return `for(${this.iteration})` + super.render(o);
    }
    optimizeNames(o, l) {
      if (super.optimizeNames(o, l))
        return this.iteration = R(this.iteration, o, l), this;
    }
    get names() {
      return P(super.names, this.iteration.names);
    }
  }
  class M extends _ {
    constructor(o, l, E, q) {
      super(), this.varKind = o, this.name = l, this.from = E, this.to = q;
    }
    render(o) {
      const l = o.es5 ? r.varKinds.var : this.varKind, { name: E, from: q, to: z } = this;
      return `for(${l} ${E}=${q}; ${E}<${z}; ${E}++)` + super.render(o);
    }
    get names() {
      const o = T(super.names, this.from);
      return T(o, this.to);
    }
  }
  class F extends _ {
    constructor(o, l, E, q) {
      super(), this.loop = o, this.varKind = l, this.name = E, this.iterable = q;
    }
    render(o) {
      return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(o);
    }
    optimizeNames(o, l) {
      if (super.optimizeNames(o, l))
        return this.iterable = R(this.iterable, o, l), this;
    }
    get names() {
      return P(super.names, this.iterable.names);
    }
  }
  class x extends v {
    constructor(o, l, E) {
      super(), this.name = o, this.args = l, this.async = E;
    }
    render(o) {
      return `${this.async ? "async " : ""}function ${this.name}(${this.args})` + super.render(o);
    }
  }
  x.kind = "func";
  class Y extends w {
    render(o) {
      return "return " + super.render(o);
    }
  }
  Y.kind = "return";
  class se extends v {
    render(o) {
      let l = "try" + super.render(o);
      return this.catch && (l += this.catch.render(o)), this.finally && (l += this.finally.render(o)), l;
    }
    optimizeNodes() {
      var o, l;
      return super.optimizeNodes(), (o = this.catch) === null || o === void 0 || o.optimizeNodes(), (l = this.finally) === null || l === void 0 || l.optimizeNodes(), this;
    }
    optimizeNames(o, l) {
      var E, q;
      return super.optimizeNames(o, l), (E = this.catch) === null || E === void 0 || E.optimizeNames(o, l), (q = this.finally) === null || q === void 0 || q.optimizeNames(o, l), this;
    }
    get names() {
      const o = super.names;
      return this.catch && P(o, this.catch.names), this.finally && P(o, this.finally.names), o;
    }
  }
  class m extends v {
    constructor(o) {
      super(), this.error = o;
    }
    render(o) {
      return `catch(${this.error})` + super.render(o);
    }
  }
  m.kind = "catch";
  class S extends v {
    render(o) {
      return "finally" + super.render(o);
    }
  }
  S.kind = "finally";
  class j {
    constructor(o, l = {}) {
      this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = { ...l, _n: l.lines ? `
` : "" }, this._extScope = o, this._scope = new r.Scope({ parent: o }), this._nodes = [new b()];
    }
    toString() {
      return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(o) {
      return this._scope.name(o);
    }
    // reserves unique name in the external scope
    scopeName(o) {
      return this._extScope.name(o);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(o, l) {
      const E = this._extScope.value(o, l);
      return (this._values[E.prefix] || (this._values[E.prefix] = /* @__PURE__ */ new Set())).add(E), E;
    }
    getScopeValue(o, l) {
      return this._extScope.getValue(o, l);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(o) {
      return this._extScope.scopeRefs(o, this._values);
    }
    scopeCode() {
      return this._extScope.scopeCode(this._values);
    }
    _def(o, l, E, q) {
      const z = this._scope.toName(l);
      return E !== void 0 && q && (this._constants[z.str] = E), this._leafNode(new i(o, z, E)), z;
    }
    // `const` declaration (`var` in es5 mode)
    const(o, l, E) {
      return this._def(r.varKinds.const, o, l, E);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(o, l, E) {
      return this._def(r.varKinds.let, o, l, E);
    }
    // `var` declaration with optional assignment
    var(o, l, E) {
      return this._def(r.varKinds.var, o, l, E);
    }
    // assignment code
    assign(o, l, E) {
      return this._leafNode(new u(o, l, E));
    }
    // `+=` code
    add(o, l) {
      return this._leafNode(new d(o, e.operators.ADD, l));
    }
    // appends passed SafeExpr to code or executes Block
    code(o) {
      return typeof o == "function" ? o() : o !== t.nil && this._leafNode(new N(o)), this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...o) {
      const l = ["{"];
      for (const [E, q] of o)
        l.length > 1 && l.push(","), l.push(E), (E !== q || this.opts.es5) && (l.push(":"), (0, t.addCodeArg)(l, q));
      return l.push("}"), new t._Code(l);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(o, l, E) {
      if (this._blockNode(new f(o)), l && E)
        this.code(l).else().code(E).endIf();
      else if (l)
        this.code(l).endIf();
      else if (E)
        throw new Error('CodeGen: "else" body without "then" body');
      return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(o) {
      return this._elseNode(new f(o));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
      return this._elseNode(new $());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
      return this._endBlockNode(f, $);
    }
    _for(o, l) {
      return this._blockNode(o), l && this.code(l).endFor(), this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(o, l) {
      return this._for(new I(o), l);
    }
    // `for` statement for a range of values
    forRange(o, l, E, q, z = this.opts.es5 ? r.varKinds.var : r.varKinds.let) {
      const B = this._scope.toName(o);
      return this._for(new M(z, B, l, E), () => q(B));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(o, l, E, q = r.varKinds.const) {
      const z = this._scope.toName(o);
      if (this.opts.es5) {
        const B = l instanceof t.Name ? l : this.var("_arr", l);
        return this.forRange("_i", 0, (0, t._)`${B}.length`, (J) => {
          this.var(z, (0, t._)`${B}[${J}]`), E(z);
        });
      }
      return this._for(new F("of", q, z, l), () => E(z));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(o, l, E, q = this.opts.es5 ? r.varKinds.var : r.varKinds.const) {
      if (this.opts.ownProperties)
        return this.forOf(o, (0, t._)`Object.keys(${l})`, E);
      const z = this._scope.toName(o);
      return this._for(new F("in", q, z, l), () => E(z));
    }
    // end `for` loop
    endFor() {
      return this._endBlockNode(_);
    }
    // `label` statement
    label(o) {
      return this._leafNode(new c(o));
    }
    // `break` statement
    break(o) {
      return this._leafNode(new h(o));
    }
    // `return` statement
    return(o) {
      const l = new Y();
      if (this._blockNode(l), this.code(o), l.nodes.length !== 1)
        throw new Error('CodeGen: "return" should have one node');
      return this._endBlockNode(Y);
    }
    // `try` statement
    try(o, l, E) {
      if (!l && !E)
        throw new Error('CodeGen: "try" without "catch" and "finally"');
      const q = new se();
      if (this._blockNode(q), this.code(o), l) {
        const z = this.name("e");
        this._currNode = q.catch = new m(z), l(z);
      }
      return E && (this._currNode = q.finally = new S(), this.code(E)), this._endBlockNode(m, S);
    }
    // `throw` statement
    throw(o) {
      return this._leafNode(new p(o));
    }
    // start self-balancing block
    block(o, l) {
      return this._blockStarts.push(this._nodes.length), o && this.code(o).endBlock(l), this;
    }
    // end the current self-balancing block
    endBlock(o) {
      const l = this._blockStarts.pop();
      if (l === void 0)
        throw new Error("CodeGen: not in self-balancing block");
      const E = this._nodes.length - l;
      if (E < 0 || o !== void 0 && E !== o)
        throw new Error(`CodeGen: wrong number of nodes: ${E} vs ${o} expected`);
      return this._nodes.length = l, this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(o, l = t.nil, E, q) {
      return this._blockNode(new x(o, l, E)), q && this.code(q).endFunc(), this;
    }
    // end function definition
    endFunc() {
      return this._endBlockNode(x);
    }
    optimize(o = 1) {
      for (; o-- > 0; )
        this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
    }
    _leafNode(o) {
      return this._currNode.nodes.push(o), this;
    }
    _blockNode(o) {
      this._currNode.nodes.push(o), this._nodes.push(o);
    }
    _endBlockNode(o, l) {
      const E = this._currNode;
      if (E instanceof o || l && E instanceof l)
        return this._nodes.pop(), this;
      throw new Error(`CodeGen: not in block "${l ? `${o.kind}/${l.kind}` : o.kind}"`);
    }
    _elseNode(o) {
      const l = this._currNode;
      if (!(l instanceof f))
        throw new Error('CodeGen: "else" without "if"');
      return this._currNode = l.else = o, this;
    }
    get _root() {
      return this._nodes[0];
    }
    get _currNode() {
      const o = this._nodes;
      return o[o.length - 1];
    }
    set _currNode(o) {
      const l = this._nodes;
      l[l.length - 1] = o;
    }
  }
  e.CodeGen = j;
  function P(g, o) {
    for (const l in o)
      g[l] = (g[l] || 0) + (o[l] || 0);
    return g;
  }
  function T(g, o) {
    return o instanceof t._CodeOrName ? P(g, o.names) : g;
  }
  function R(g, o, l) {
    if (g instanceof t.Name)
      return E(g);
    if (!q(g))
      return g;
    return new t._Code(g._items.reduce((z, B) => (B instanceof t.Name && (B = E(B)), B instanceof t._Code ? z.push(...B._items) : z.push(B), z), []));
    function E(z) {
      const B = l[z.str];
      return B === void 0 || o[z.str] !== 1 ? z : (delete o[z.str], B);
    }
    function q(z) {
      return z instanceof t._Code && z._items.some((B) => B instanceof t.Name && o[B.str] === 1 && l[B.str] !== void 0);
    }
  }
  function D(g, o) {
    for (const l in o)
      g[l] = (g[l] || 0) - (o[l] || 0);
  }
  function O(g) {
    return typeof g == "boolean" || typeof g == "number" || g === null ? !g : (0, t._)`!${k(g)}`;
  }
  e.not = O;
  const G = y(e.operators.AND);
  function Ie(...g) {
    return g.reduce(G);
  }
  e.and = Ie;
  const Pe = y(e.operators.OR);
  function C(...g) {
    return g.reduce(Pe);
  }
  e.or = C;
  function y(g) {
    return (o, l) => o === t.nil ? l : l === t.nil ? o : (0, t._)`${k(o)} ${g} ${k(l)}`;
  }
  function k(g) {
    return g instanceof t.Name ? g : (0, t._)`(${g})`;
  }
})(H);
var A = {};
Object.defineProperty(A, "__esModule", { value: !0 });
A.checkStrictMode = A.getErrorPath = A.Type = A.useFunc = A.setEvaluated = A.evaluatedPropsToName = A.mergeEvaluated = A.eachItem = A.unescapeJsonPointer = A.escapeJsonPointer = A.escapeFragment = A.unescapeFragment = A.schemaRefOrVal = A.schemaHasRulesButRef = A.schemaHasRules = A.checkUnknownRules = A.alwaysValidSchema = A.toHash = void 0;
const W = H, Ds = et;
function Vs(e) {
  const t = {};
  for (const r of e)
    t[r] = !0;
  return t;
}
A.toHash = Vs;
function qs(e, t) {
  return typeof t == "boolean" ? t : Object.keys(t).length === 0 ? !0 : (On(e, t), !jn(t, e.self.RULES.all));
}
A.alwaysValidSchema = qs;
function On(e, t = e.schema) {
  const { opts: r, self: n } = e;
  if (!r.strictSchema || typeof t == "boolean")
    return;
  const s = n.RULES.keywords;
  for (const a in t)
    s[a] || Cn(e, `unknown keyword: "${a}"`);
}
A.checkUnknownRules = On;
function jn(e, t) {
  if (typeof e == "boolean")
    return !e;
  for (const r in e)
    if (t[r])
      return !0;
  return !1;
}
A.schemaHasRules = jn;
function zs(e, t) {
  if (typeof e == "boolean")
    return !e;
  for (const r in e)
    if (r !== "$ref" && t.all[r])
      return !0;
  return !1;
}
A.schemaHasRulesButRef = zs;
function Us({ topSchemaRef: e, schemaPath: t }, r, n, s) {
  if (!s) {
    if (typeof r == "number" || typeof r == "boolean")
      return r;
    if (typeof r == "string")
      return (0, W._)`${r}`;
  }
  return (0, W._)`${e}${t}${(0, W.getProperty)(n)}`;
}
A.schemaRefOrVal = Us;
function xs(e) {
  return Tn(decodeURIComponent(e));
}
A.unescapeFragment = xs;
function Ks(e) {
  return encodeURIComponent(sr(e));
}
A.escapeFragment = Ks;
function sr(e) {
  return typeof e == "number" ? `${e}` : e.replace(/~/g, "~0").replace(/\//g, "~1");
}
A.escapeJsonPointer = sr;
function Tn(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
A.unescapeJsonPointer = Tn;
function Ls(e, t) {
  if (Array.isArray(e))
    for (const r of e)
      t(r);
  else
    t(e);
}
A.eachItem = Ls;
function en({ mergeNames: e, mergeToName: t, mergeValues: r, resultToName: n }) {
  return (s, a, i, u) => {
    const d = i === void 0 ? a : i instanceof W.Name ? (a instanceof W.Name ? e(s, a, i) : t(s, a, i), i) : a instanceof W.Name ? (t(s, i, a), a) : r(a, i);
    return u === W.Name && !(d instanceof W.Name) ? n(s, d) : d;
  };
}
A.mergeEvaluated = {
  props: en({
    mergeNames: (e, t, r) => e.if((0, W._)`${r} !== true && ${t} !== undefined`, () => {
      e.if((0, W._)`${t} === true`, () => e.assign(r, !0), () => e.assign(r, (0, W._)`${r} || {}`).code((0, W._)`Object.assign(${r}, ${t})`));
    }),
    mergeToName: (e, t, r) => e.if((0, W._)`${r} !== true`, () => {
      t === !0 ? e.assign(r, !0) : (e.assign(r, (0, W._)`${r} || {}`), ar(e, r, t));
    }),
    mergeValues: (e, t) => e === !0 ? !0 : { ...e, ...t },
    resultToName: In
  }),
  items: en({
    mergeNames: (e, t, r) => e.if((0, W._)`${r} !== true && ${t} !== undefined`, () => e.assign(r, (0, W._)`${t} === true ? true : ${r} > ${t} ? ${r} : ${t}`)),
    mergeToName: (e, t, r) => e.if((0, W._)`${r} !== true`, () => e.assign(r, t === !0 ? !0 : (0, W._)`${r} > ${t} ? ${r} : ${t}`)),
    mergeValues: (e, t) => e === !0 ? !0 : Math.max(e, t),
    resultToName: (e, t) => e.var("items", t)
  })
};
function In(e, t) {
  if (t === !0)
    return e.var("props", !0);
  const r = e.var("props", (0, W._)`{}`);
  return t !== void 0 && ar(e, r, t), r;
}
A.evaluatedPropsToName = In;
function ar(e, t, r) {
  Object.keys(r).forEach((n) => e.assign((0, W._)`${t}${(0, W.getProperty)(n)}`, !0));
}
A.setEvaluated = ar;
const tn = {};
function Hs(e, t) {
  return e.scopeValue("func", {
    ref: t,
    code: tn[t.code] || (tn[t.code] = new Ds._Code(t.code))
  });
}
A.useFunc = Hs;
var Xt;
(function(e) {
  e[e.Num = 0] = "Num", e[e.Str = 1] = "Str";
})(Xt || (A.Type = Xt = {}));
function Gs(e, t, r) {
  if (e instanceof W.Name) {
    const n = t === Xt.Num;
    return r ? n ? (0, W._)`"[" + ${e} + "]"` : (0, W._)`"['" + ${e} + "']"` : n ? (0, W._)`"/" + ${e}` : (0, W._)`"/" + ${e}.replace(/~/g, "~0").replace(/\\//g, "~1")`;
  }
  return r ? (0, W.getProperty)(e).toString() : "/" + sr(e);
}
A.getErrorPath = Gs;
function Cn(e, t, r = e.opts.strictSchema) {
  if (r) {
    if (t = `strict mode: ${t}`, r === !0)
      throw new Error(t);
    e.self.logger.warn(t);
  }
}
A.checkStrictMode = Cn;
var $e = {};
Object.defineProperty($e, "__esModule", { value: !0 });
const ne = H, Js = {
  // validation function arguments
  data: new ne.Name("data"),
  // data passed to validation function
  // args passed from referencing schema
  valCxt: new ne.Name("valCxt"),
  // validation/data context - should not be used directly, it is destructured to the names below
  instancePath: new ne.Name("instancePath"),
  parentData: new ne.Name("parentData"),
  parentDataProperty: new ne.Name("parentDataProperty"),
  rootData: new ne.Name("rootData"),
  // root data - same as the data passed to the first/top validation function
  dynamicAnchors: new ne.Name("dynamicAnchors"),
  // used to support recursiveRef and dynamicRef
  // function scoped variables
  vErrors: new ne.Name("vErrors"),
  // null or array of validation errors
  errors: new ne.Name("errors"),
  // counter of validation errors
  this: new ne.Name("this"),
  // "globals"
  self: new ne.Name("self"),
  scope: new ne.Name("scope"),
  // JTD serialize/parse name for JSON string and position
  json: new ne.Name("json"),
  jsonPos: new ne.Name("jsonPos"),
  jsonLen: new ne.Name("jsonLen"),
  jsonPart: new ne.Name("jsonPart")
};
$e.default = Js;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.extendErrors = e.resetErrorsCount = e.reportExtraError = e.reportError = e.keyword$DataError = e.keywordError = void 0;
  const t = H, r = A, n = $e;
  e.keywordError = {
    message: ({ keyword: $ }) => (0, t.str)`must pass "${$}" keyword validation`
  }, e.keyword$DataError = {
    message: ({ keyword: $, schemaType: f }) => f ? (0, t.str)`"${$}" keyword must be ${f} ($data)` : (0, t.str)`"${$}" keyword is invalid ($data)`
  };
  function s($, f = e.keywordError, _, I) {
    const { it: M } = $, { gen: F, compositeRule: x, allErrors: Y } = M, se = p($, f, _);
    I ?? (x || Y) ? d(F, se) : c(M, (0, t._)`[${se}]`);
  }
  e.reportError = s;
  function a($, f = e.keywordError, _) {
    const { it: I } = $, { gen: M, compositeRule: F, allErrors: x } = I, Y = p($, f, _);
    d(M, Y), F || x || c(I, n.default.vErrors);
  }
  e.reportExtraError = a;
  function i($, f) {
    $.assign(n.default.errors, f), $.if((0, t._)`${n.default.vErrors} !== null`, () => $.if(f, () => $.assign((0, t._)`${n.default.vErrors}.length`, f), () => $.assign(n.default.vErrors, null)));
  }
  e.resetErrorsCount = i;
  function u({ gen: $, keyword: f, schemaValue: _, data: I, errsCount: M, it: F }) {
    if (M === void 0)
      throw new Error("ajv implementation error");
    const x = $.name("err");
    $.forRange("i", M, n.default.errors, (Y) => {
      $.const(x, (0, t._)`${n.default.vErrors}[${Y}]`), $.if((0, t._)`${x}.instancePath === undefined`, () => $.assign((0, t._)`${x}.instancePath`, (0, t.strConcat)(n.default.instancePath, F.errorPath))), $.assign((0, t._)`${x}.schemaPath`, (0, t.str)`${F.errSchemaPath}/${f}`), F.opts.verbose && ($.assign((0, t._)`${x}.schema`, _), $.assign((0, t._)`${x}.data`, I));
    });
  }
  e.extendErrors = u;
  function d($, f) {
    const _ = $.const("err", f);
    $.if((0, t._)`${n.default.vErrors} === null`, () => $.assign(n.default.vErrors, (0, t._)`[${_}]`), (0, t._)`${n.default.vErrors}.push(${_})`), $.code((0, t._)`${n.default.errors}++`);
  }
  function c($, f) {
    const { gen: _, validateName: I, schemaEnv: M } = $;
    M.$async ? _.throw((0, t._)`new ${$.ValidationError}(${f})`) : (_.assign((0, t._)`${I}.errors`, f), _.return(!1));
  }
  const h = {
    keyword: new t.Name("keyword"),
    schemaPath: new t.Name("schemaPath"),
    // also used in JTD errors
    params: new t.Name("params"),
    propertyName: new t.Name("propertyName"),
    message: new t.Name("message"),
    schema: new t.Name("schema"),
    parentSchema: new t.Name("parentSchema")
  };
  function p($, f, _) {
    const { createErrors: I } = $.it;
    return I === !1 ? (0, t._)`{}` : N($, f, _);
  }
  function N($, f, _ = {}) {
    const { gen: I, it: M } = $, F = [
      w(M, _),
      v($, _)
    ];
    return b($, f, F), I.object(...F);
  }
  function w({ errorPath: $ }, { instancePath: f }) {
    const _ = f ? (0, t.str)`${$}${(0, r.getErrorPath)(f, r.Type.Str)}` : $;
    return [n.default.instancePath, (0, t.strConcat)(n.default.instancePath, _)];
  }
  function v({ keyword: $, it: { errSchemaPath: f } }, { schemaPath: _, parentSchema: I }) {
    let M = I ? f : (0, t.str)`${f}/${$}`;
    return _ && (M = (0, t.str)`${M}${(0, r.getErrorPath)(_, r.Type.Str)}`), [h.schemaPath, M];
  }
  function b($, { params: f, message: _ }, I) {
    const { keyword: M, data: F, schemaValue: x, it: Y } = $, { opts: se, propertyName: m, topSchemaRef: S, schemaPath: j } = Y;
    I.push([h.keyword, M], [h.params, typeof f == "function" ? f($) : f || (0, t._)`{}`]), se.messages && I.push([h.message, typeof _ == "function" ? _($) : _]), se.verbose && I.push([h.schema, x], [h.parentSchema, (0, t._)`${S}${j}`], [n.default.data, F]), m && I.push([h.propertyName, m]);
  }
})(tt);
Object.defineProperty(qe, "__esModule", { value: !0 });
qe.boolOrEmptySchema = qe.topBoolOrEmptySchema = void 0;
const Bs = tt, Ws = H, Xs = $e, Ys = {
  message: "boolean schema is false"
};
function Qs(e) {
  const { gen: t, schema: r, validateName: n } = e;
  r === !1 ? An(e, !1) : typeof r == "object" && r.$async === !0 ? t.return(Xs.default.data) : (t.assign((0, Ws._)`${n}.errors`, null), t.return(!0));
}
qe.topBoolOrEmptySchema = Qs;
function Zs(e, t) {
  const { gen: r, schema: n } = e;
  n === !1 ? (r.var(t, !1), An(e)) : r.var(t, !0);
}
qe.boolOrEmptySchema = Zs;
function An(e, t) {
  const { gen: r, data: n } = e, s = {
    gen: r,
    keyword: "false schema",
    data: n,
    schema: !1,
    schemaCode: !1,
    schemaValue: !1,
    params: {},
    it: e
  };
  (0, Bs.reportError)(s, Ys, void 0, t);
}
var Z = {}, je = {};
Object.defineProperty(je, "__esModule", { value: !0 });
je.getRules = je.isJSONType = void 0;
const ea = ["string", "number", "integer", "boolean", "null", "object", "array"], ta = new Set(ea);
function ra(e) {
  return typeof e == "string" && ta.has(e);
}
je.isJSONType = ra;
function na() {
  const e = {
    number: { type: "number", rules: [] },
    string: { type: "string", rules: [] },
    array: { type: "array", rules: [] },
    object: { type: "object", rules: [] }
  };
  return {
    types: { ...e, integer: !0, boolean: !0, null: !0 },
    rules: [{ rules: [] }, e.number, e.string, e.array, e.object],
    post: { rules: [] },
    all: {},
    keywords: {}
  };
}
je.getRules = na;
var ge = {};
Object.defineProperty(ge, "__esModule", { value: !0 });
ge.shouldUseRule = ge.shouldUseGroup = ge.schemaHasRulesForType = void 0;
function sa({ schema: e, self: t }, r) {
  const n = t.RULES.types[r];
  return n && n !== !0 && Mn(e, n);
}
ge.schemaHasRulesForType = sa;
function Mn(e, t) {
  return t.rules.some((r) => Fn(e, r));
}
ge.shouldUseGroup = Mn;
function Fn(e, t) {
  var r;
  return e[t.keyword] !== void 0 || ((r = t.definition.implements) === null || r === void 0 ? void 0 : r.some((n) => e[n] !== void 0));
}
ge.shouldUseRule = Fn;
Object.defineProperty(Z, "__esModule", { value: !0 });
Z.reportTypeError = Z.checkDataTypes = Z.checkDataType = Z.coerceAndCheckDataType = Z.getJSONTypes = Z.getSchemaTypes = Z.DataType = void 0;
const aa = je, oa = ge, ia = tt, K = H, Dn = A;
var De;
(function(e) {
  e[e.Correct = 0] = "Correct", e[e.Wrong = 1] = "Wrong";
})(De || (Z.DataType = De = {}));
function ca(e) {
  const t = Vn(e.type);
  if (t.includes("null")) {
    if (e.nullable === !1)
      throw new Error("type: null contradicts nullable: false");
  } else {
    if (!t.length && e.nullable !== void 0)
      throw new Error('"nullable" cannot be used without "type"');
    e.nullable === !0 && t.push("null");
  }
  return t;
}
Z.getSchemaTypes = ca;
function Vn(e) {
  const t = Array.isArray(e) ? e : e ? [e] : [];
  if (t.every(aa.isJSONType))
    return t;
  throw new Error("type must be JSONType or JSONType[]: " + t.join(","));
}
Z.getJSONTypes = Vn;
function ua(e, t) {
  const { gen: r, data: n, opts: s } = e, a = la(t, s.coerceTypes), i = t.length > 0 && !(a.length === 0 && t.length === 1 && (0, oa.schemaHasRulesForType)(e, t[0]));
  if (i) {
    const u = or(t, n, s.strictNumbers, De.Wrong);
    r.if(u, () => {
      a.length ? da(e, t, a) : ir(e);
    });
  }
  return i;
}
Z.coerceAndCheckDataType = ua;
const qn = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
function la(e, t) {
  return t ? e.filter((r) => qn.has(r) || t === "array" && r === "array") : [];
}
function da(e, t, r) {
  const { gen: n, data: s, opts: a } = e, i = n.let("dataType", (0, K._)`typeof ${s}`), u = n.let("coerced", (0, K._)`undefined`);
  a.coerceTypes === "array" && n.if((0, K._)`${i} == 'object' && Array.isArray(${s}) && ${s}.length == 1`, () => n.assign(s, (0, K._)`${s}[0]`).assign(i, (0, K._)`typeof ${s}`).if(or(t, s, a.strictNumbers), () => n.assign(u, s))), n.if((0, K._)`${u} !== undefined`);
  for (const c of r)
    (qn.has(c) || c === "array" && a.coerceTypes === "array") && d(c);
  n.else(), ir(e), n.endIf(), n.if((0, K._)`${u} !== undefined`, () => {
    n.assign(s, u), fa(e, u);
  });
  function d(c) {
    switch (c) {
      case "string":
        n.elseIf((0, K._)`${i} == "number" || ${i} == "boolean"`).assign(u, (0, K._)`"" + ${s}`).elseIf((0, K._)`${s} === null`).assign(u, (0, K._)`""`);
        return;
      case "number":
        n.elseIf((0, K._)`${i} == "boolean" || ${s} === null
              || (${i} == "string" && ${s} && ${s} == +${s})`).assign(u, (0, K._)`+${s}`);
        return;
      case "integer":
        n.elseIf((0, K._)`${i} === "boolean" || ${s} === null
              || (${i} === "string" && ${s} && ${s} == +${s} && !(${s} % 1))`).assign(u, (0, K._)`+${s}`);
        return;
      case "boolean":
        n.elseIf((0, K._)`${s} === "false" || ${s} === 0 || ${s} === null`).assign(u, !1).elseIf((0, K._)`${s} === "true" || ${s} === 1`).assign(u, !0);
        return;
      case "null":
        n.elseIf((0, K._)`${s} === "" || ${s} === 0 || ${s} === false`), n.assign(u, null);
        return;
      case "array":
        n.elseIf((0, K._)`${i} === "string" || ${i} === "number"
              || ${i} === "boolean" || ${s} === null`).assign(u, (0, K._)`[${s}]`);
    }
  }
}
function fa({ gen: e, parentData: t, parentDataProperty: r }, n) {
  e.if((0, K._)`${t} !== undefined`, () => e.assign((0, K._)`${t}[${r}]`, n));
}
function Yt(e, t, r, n = De.Correct) {
  const s = n === De.Correct ? K.operators.EQ : K.operators.NEQ;
  let a;
  switch (e) {
    case "null":
      return (0, K._)`${t} ${s} null`;
    case "array":
      a = (0, K._)`Array.isArray(${t})`;
      break;
    case "object":
      a = (0, K._)`${t} && typeof ${t} == "object" && !Array.isArray(${t})`;
      break;
    case "integer":
      a = i((0, K._)`!(${t} % 1) && !isNaN(${t})`);
      break;
    case "number":
      a = i();
      break;
    default:
      return (0, K._)`typeof ${t} ${s} ${e}`;
  }
  return n === De.Correct ? a : (0, K.not)(a);
  function i(u = K.nil) {
    return (0, K.and)((0, K._)`typeof ${t} == "number"`, u, r ? (0, K._)`isFinite(${t})` : K.nil);
  }
}
Z.checkDataType = Yt;
function or(e, t, r, n) {
  if (e.length === 1)
    return Yt(e[0], t, r, n);
  let s;
  const a = (0, Dn.toHash)(e);
  if (a.array && a.object) {
    const i = (0, K._)`typeof ${t} != "object"`;
    s = a.null ? i : (0, K._)`!${t} || ${i}`, delete a.null, delete a.array, delete a.object;
  } else
    s = K.nil;
  a.number && delete a.integer;
  for (const i in a)
    s = (0, K.and)(s, Yt(i, t, r, n));
  return s;
}
Z.checkDataTypes = or;
const ha = {
  message: ({ schema: e }) => `must be ${e}`,
  params: ({ schema: e, schemaValue: t }) => typeof e == "string" ? (0, K._)`{type: ${e}}` : (0, K._)`{type: ${t}}`
};
function ir(e) {
  const t = pa(e);
  (0, ia.reportError)(t, ha);
}
Z.reportTypeError = ir;
function pa(e) {
  const { gen: t, data: r, schema: n } = e, s = (0, Dn.schemaRefOrVal)(e, n, "type");
  return {
    gen: t,
    keyword: "type",
    data: r,
    schema: n.type,
    schemaCode: s,
    schemaValue: s,
    parentSchema: n,
    params: {},
    it: e
  };
}
var wt = {};
Object.defineProperty(wt, "__esModule", { value: !0 });
wt.assignDefaults = void 0;
const Ae = H, ma = A;
function ya(e, t) {
  const { properties: r, items: n } = e.schema;
  if (t === "object" && r)
    for (const s in r)
      rn(e, s, r[s].default);
  else t === "array" && Array.isArray(n) && n.forEach((s, a) => rn(e, a, s.default));
}
wt.assignDefaults = ya;
function rn(e, t, r) {
  const { gen: n, compositeRule: s, data: a, opts: i } = e;
  if (r === void 0)
    return;
  const u = (0, Ae._)`${a}${(0, Ae.getProperty)(t)}`;
  if (s) {
    (0, ma.checkStrictMode)(e, `default is ignored for: ${u}`);
    return;
  }
  let d = (0, Ae._)`${u} === undefined`;
  i.useDefaults === "empty" && (d = (0, Ae._)`${d} || ${u} === null || ${u} === ""`), n.if(d, (0, Ae._)`${u} = ${(0, Ae.stringify)(r)}`);
}
var me = {}, L = {};
Object.defineProperty(L, "__esModule", { value: !0 });
L.validateUnion = L.validateArray = L.usePattern = L.callValidateCode = L.schemaProperties = L.allSchemaProperties = L.noPropertyInData = L.propertyInData = L.isOwnProperty = L.hasPropFunc = L.reportMissingProp = L.checkMissingProp = L.checkReportMissingProp = void 0;
const X = H, cr = A, we = $e, $a = A;
function ga(e, t) {
  const { gen: r, data: n, it: s } = e;
  r.if(lr(r, n, t, s.opts.ownProperties), () => {
    e.setParams({ missingProperty: (0, X._)`${t}` }, !0), e.error();
  });
}
L.checkReportMissingProp = ga;
function _a({ gen: e, data: t, it: { opts: r } }, n, s) {
  return (0, X.or)(...n.map((a) => (0, X.and)(lr(e, t, a, r.ownProperties), (0, X._)`${s} = ${a}`)));
}
L.checkMissingProp = _a;
function va(e, t) {
  e.setParams({ missingProperty: t }, !0), e.error();
}
L.reportMissingProp = va;
function zn(e) {
  return e.scopeValue("func", {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    ref: Object.prototype.hasOwnProperty,
    code: (0, X._)`Object.prototype.hasOwnProperty`
  });
}
L.hasPropFunc = zn;
function ur(e, t, r) {
  return (0, X._)`${zn(e)}.call(${t}, ${r})`;
}
L.isOwnProperty = ur;
function wa(e, t, r, n) {
  const s = (0, X._)`${t}${(0, X.getProperty)(r)} !== undefined`;
  return n ? (0, X._)`${s} && ${ur(e, t, r)}` : s;
}
L.propertyInData = wa;
function lr(e, t, r, n) {
  const s = (0, X._)`${t}${(0, X.getProperty)(r)} === undefined`;
  return n ? (0, X.or)(s, (0, X.not)(ur(e, t, r))) : s;
}
L.noPropertyInData = lr;
function Un(e) {
  return e ? Object.keys(e).filter((t) => t !== "__proto__") : [];
}
L.allSchemaProperties = Un;
function ba(e, t) {
  return Un(t).filter((r) => !(0, cr.alwaysValidSchema)(e, t[r]));
}
L.schemaProperties = ba;
function Ea({ schemaCode: e, data: t, it: { gen: r, topSchemaRef: n, schemaPath: s, errorPath: a }, it: i }, u, d, c) {
  const h = c ? (0, X._)`${e}, ${t}, ${n}${s}` : t, p = [
    [we.default.instancePath, (0, X.strConcat)(we.default.instancePath, a)],
    [we.default.parentData, i.parentData],
    [we.default.parentDataProperty, i.parentDataProperty],
    [we.default.rootData, we.default.rootData]
  ];
  i.opts.dynamicRef && p.push([we.default.dynamicAnchors, we.default.dynamicAnchors]);
  const N = (0, X._)`${h}, ${r.object(...p)}`;
  return d !== X.nil ? (0, X._)`${u}.call(${d}, ${N})` : (0, X._)`${u}(${N})`;
}
L.callValidateCode = Ea;
const Sa = (0, X._)`new RegExp`;
function Pa({ gen: e, it: { opts: t } }, r) {
  const n = t.unicodeRegExp ? "u" : "", { regExp: s } = t.code, a = s(r, n);
  return e.scopeValue("pattern", {
    key: a.toString(),
    ref: a,
    code: (0, X._)`${s.code === "new RegExp" ? Sa : (0, $a.useFunc)(e, s)}(${r}, ${n})`
  });
}
L.usePattern = Pa;
function Na(e) {
  const { gen: t, data: r, keyword: n, it: s } = e, a = t.name("valid");
  if (s.allErrors) {
    const u = t.let("valid", !0);
    return i(() => t.assign(u, !1)), u;
  }
  return t.var(a, !0), i(() => t.break()), a;
  function i(u) {
    const d = t.const("len", (0, X._)`${r}.length`);
    t.forRange("i", 0, d, (c) => {
      e.subschema({
        keyword: n,
        dataProp: c,
        dataPropType: cr.Type.Num
      }, a), t.if((0, X.not)(a), u);
    });
  }
}
L.validateArray = Na;
function Ra(e) {
  const { gen: t, schema: r, keyword: n, it: s } = e;
  if (!Array.isArray(r))
    throw new Error("ajv implementation error");
  if (r.some((d) => (0, cr.alwaysValidSchema)(s, d)) && !s.opts.unevaluated)
    return;
  const i = t.let("valid", !1), u = t.name("_valid");
  t.block(() => r.forEach((d, c) => {
    const h = e.subschema({
      keyword: n,
      schemaProp: c,
      compositeRule: !0
    }, u);
    t.assign(i, (0, X._)`${i} || ${u}`), e.mergeValidEvaluated(h, u) || t.if((0, X.not)(i));
  })), e.result(i, () => e.reset(), () => e.error(!0));
}
L.validateUnion = Ra;
Object.defineProperty(me, "__esModule", { value: !0 });
me.validateKeywordUsage = me.validSchemaType = me.funcKeywordCode = me.macroKeywordCode = void 0;
const ae = H, Re = $e, ka = L, Oa = tt;
function ja(e, t) {
  const { gen: r, keyword: n, schema: s, parentSchema: a, it: i } = e, u = t.macro.call(i.self, s, a, i), d = xn(r, n, u);
  i.opts.validateSchema !== !1 && i.self.validateSchema(u, !0);
  const c = r.name("valid");
  e.subschema({
    schema: u,
    schemaPath: ae.nil,
    errSchemaPath: `${i.errSchemaPath}/${n}`,
    topSchemaRef: d,
    compositeRule: !0
  }, c), e.pass(c, () => e.error(!0));
}
me.macroKeywordCode = ja;
function Ta(e, t) {
  var r;
  const { gen: n, keyword: s, schema: a, parentSchema: i, $data: u, it: d } = e;
  Ca(d, t);
  const c = !u && t.compile ? t.compile.call(d.self, a, i, d) : t.validate, h = xn(n, s, c), p = n.let("valid");
  e.block$data(p, N), e.ok((r = t.valid) !== null && r !== void 0 ? r : p);
  function N() {
    if (t.errors === !1)
      b(), t.modifying && nn(e), $(() => e.error());
    else {
      const f = t.async ? w() : v();
      t.modifying && nn(e), $(() => Ia(e, f));
    }
  }
  function w() {
    const f = n.let("ruleErrs", null);
    return n.try(() => b((0, ae._)`await `), (_) => n.assign(p, !1).if((0, ae._)`${_} instanceof ${d.ValidationError}`, () => n.assign(f, (0, ae._)`${_}.errors`), () => n.throw(_))), f;
  }
  function v() {
    const f = (0, ae._)`${h}.errors`;
    return n.assign(f, null), b(ae.nil), f;
  }
  function b(f = t.async ? (0, ae._)`await ` : ae.nil) {
    const _ = d.opts.passContext ? Re.default.this : Re.default.self, I = !("compile" in t && !u || t.schema === !1);
    n.assign(p, (0, ae._)`${f}${(0, ka.callValidateCode)(e, h, _, I)}`, t.modifying);
  }
  function $(f) {
    var _;
    n.if((0, ae.not)((_ = t.valid) !== null && _ !== void 0 ? _ : p), f);
  }
}
me.funcKeywordCode = Ta;
function nn(e) {
  const { gen: t, data: r, it: n } = e;
  t.if(n.parentData, () => t.assign(r, (0, ae._)`${n.parentData}[${n.parentDataProperty}]`));
}
function Ia(e, t) {
  const { gen: r } = e;
  r.if((0, ae._)`Array.isArray(${t})`, () => {
    r.assign(Re.default.vErrors, (0, ae._)`${Re.default.vErrors} === null ? ${t} : ${Re.default.vErrors}.concat(${t})`).assign(Re.default.errors, (0, ae._)`${Re.default.vErrors}.length`), (0, Oa.extendErrors)(e);
  }, () => e.error());
}
function Ca({ schemaEnv: e }, t) {
  if (t.async && !e.$async)
    throw new Error("async keyword in sync schema");
}
function xn(e, t, r) {
  if (r === void 0)
    throw new Error(`keyword "${t}" failed to compile`);
  return e.scopeValue("keyword", typeof r == "function" ? { ref: r } : { ref: r, code: (0, ae.stringify)(r) });
}
function Aa(e, t, r = !1) {
  return !t.length || t.some((n) => n === "array" ? Array.isArray(e) : n === "object" ? e && typeof e == "object" && !Array.isArray(e) : typeof e == n || r && typeof e > "u");
}
me.validSchemaType = Aa;
function Ma({ schema: e, opts: t, self: r, errSchemaPath: n }, s, a) {
  if (Array.isArray(s.keyword) ? !s.keyword.includes(a) : s.keyword !== a)
    throw new Error("ajv implementation error");
  const i = s.dependencies;
  if (i?.some((u) => !Object.prototype.hasOwnProperty.call(e, u)))
    throw new Error(`parent schema must have dependencies of ${a}: ${i.join(",")}`);
  if (s.validateSchema && !s.validateSchema(e[a])) {
    const d = `keyword "${a}" value is invalid at path "${n}": ` + r.errorsText(s.validateSchema.errors);
    if (t.validateSchema === "log")
      r.logger.error(d);
    else
      throw new Error(d);
  }
}
me.validateKeywordUsage = Ma;
var Se = {};
Object.defineProperty(Se, "__esModule", { value: !0 });
Se.extendSubschemaMode = Se.extendSubschemaData = Se.getSubschema = void 0;
const pe = H, Kn = A;
function Fa(e, { keyword: t, schemaProp: r, schema: n, schemaPath: s, errSchemaPath: a, topSchemaRef: i }) {
  if (t !== void 0 && n !== void 0)
    throw new Error('both "keyword" and "schema" passed, only one allowed');
  if (t !== void 0) {
    const u = e.schema[t];
    return r === void 0 ? {
      schema: u,
      schemaPath: (0, pe._)`${e.schemaPath}${(0, pe.getProperty)(t)}`,
      errSchemaPath: `${e.errSchemaPath}/${t}`
    } : {
      schema: u[r],
      schemaPath: (0, pe._)`${e.schemaPath}${(0, pe.getProperty)(t)}${(0, pe.getProperty)(r)}`,
      errSchemaPath: `${e.errSchemaPath}/${t}/${(0, Kn.escapeFragment)(r)}`
    };
  }
  if (n !== void 0) {
    if (s === void 0 || a === void 0 || i === void 0)
      throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
    return {
      schema: n,
      schemaPath: s,
      topSchemaRef: i,
      errSchemaPath: a
    };
  }
  throw new Error('either "keyword" or "schema" must be passed');
}
Se.getSubschema = Fa;
function Da(e, t, { dataProp: r, dataPropType: n, data: s, dataTypes: a, propertyName: i }) {
  if (s !== void 0 && r !== void 0)
    throw new Error('both "data" and "dataProp" passed, only one allowed');
  const { gen: u } = t;
  if (r !== void 0) {
    const { errorPath: c, dataPathArr: h, opts: p } = t, N = u.let("data", (0, pe._)`${t.data}${(0, pe.getProperty)(r)}`, !0);
    d(N), e.errorPath = (0, pe.str)`${c}${(0, Kn.getErrorPath)(r, n, p.jsPropertySyntax)}`, e.parentDataProperty = (0, pe._)`${r}`, e.dataPathArr = [...h, e.parentDataProperty];
  }
  if (s !== void 0) {
    const c = s instanceof pe.Name ? s : u.let("data", s, !0);
    d(c), i !== void 0 && (e.propertyName = i);
  }
  a && (e.dataTypes = a);
  function d(c) {
    e.data = c, e.dataLevel = t.dataLevel + 1, e.dataTypes = [], t.definedProperties = /* @__PURE__ */ new Set(), e.parentData = t.data, e.dataNames = [...t.dataNames, c];
  }
}
Se.extendSubschemaData = Da;
function Va(e, { jtdDiscriminator: t, jtdMetadata: r, compositeRule: n, createErrors: s, allErrors: a }) {
  n !== void 0 && (e.compositeRule = n), s !== void 0 && (e.createErrors = s), a !== void 0 && (e.allErrors = a), e.jtdDiscriminator = t, e.jtdMetadata = r;
}
Se.extendSubschemaMode = Va;
var re = {}, Ln = function e(t, r) {
  if (t === r) return !0;
  if (t && r && typeof t == "object" && typeof r == "object") {
    if (t.constructor !== r.constructor) return !1;
    var n, s, a;
    if (Array.isArray(t)) {
      if (n = t.length, n != r.length) return !1;
      for (s = n; s-- !== 0; )
        if (!e(t[s], r[s])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
    if (a = Object.keys(t), n = a.length, n !== Object.keys(r).length) return !1;
    for (s = n; s-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[s])) return !1;
    for (s = n; s-- !== 0; ) {
      var i = a[s];
      if (!e(t[i], r[i])) return !1;
    }
    return !0;
  }
  return t !== t && r !== r;
}, Hn = { exports: {} }, Ee = Hn.exports = function(e, t, r) {
  typeof t == "function" && (r = t, t = {}), r = t.cb || r;
  var n = typeof r == "function" ? r : r.pre || function() {
  }, s = r.post || function() {
  };
  dt(t, n, s, e, "", e);
};
Ee.keywords = {
  additionalItems: !0,
  items: !0,
  contains: !0,
  additionalProperties: !0,
  propertyNames: !0,
  not: !0,
  if: !0,
  then: !0,
  else: !0
};
Ee.arrayKeywords = {
  items: !0,
  allOf: !0,
  anyOf: !0,
  oneOf: !0
};
Ee.propsKeywords = {
  $defs: !0,
  definitions: !0,
  properties: !0,
  patternProperties: !0,
  dependencies: !0
};
Ee.skipKeywords = {
  default: !0,
  enum: !0,
  const: !0,
  required: !0,
  maximum: !0,
  minimum: !0,
  exclusiveMaximum: !0,
  exclusiveMinimum: !0,
  multipleOf: !0,
  maxLength: !0,
  minLength: !0,
  pattern: !0,
  format: !0,
  maxItems: !0,
  minItems: !0,
  uniqueItems: !0,
  maxProperties: !0,
  minProperties: !0
};
function dt(e, t, r, n, s, a, i, u, d, c) {
  if (n && typeof n == "object" && !Array.isArray(n)) {
    t(n, s, a, i, u, d, c);
    for (var h in n) {
      var p = n[h];
      if (Array.isArray(p)) {
        if (h in Ee.arrayKeywords)
          for (var N = 0; N < p.length; N++)
            dt(e, t, r, p[N], s + "/" + h + "/" + N, a, s, h, n, N);
      } else if (h in Ee.propsKeywords) {
        if (p && typeof p == "object")
          for (var w in p)
            dt(e, t, r, p[w], s + "/" + h + "/" + qa(w), a, s, h, n, w);
      } else (h in Ee.keywords || e.allKeys && !(h in Ee.skipKeywords)) && dt(e, t, r, p, s + "/" + h, a, s, h, n);
    }
    r(n, s, a, i, u, d, c);
  }
}
function qa(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
var za = Hn.exports;
Object.defineProperty(re, "__esModule", { value: !0 });
re.getSchemaRefs = re.resolveUrl = re.normalizeId = re._getFullPath = re.getFullPath = re.inlineRef = void 0;
const Ua = A, xa = Ln, Ka = za, La = /* @__PURE__ */ new Set([
  "type",
  "format",
  "pattern",
  "maxLength",
  "minLength",
  "maxProperties",
  "minProperties",
  "maxItems",
  "minItems",
  "maximum",
  "minimum",
  "uniqueItems",
  "multipleOf",
  "required",
  "enum",
  "const"
]);
function Ha(e, t = !0) {
  return typeof e == "boolean" ? !0 : t === !0 ? !Qt(e) : t ? Gn(e) <= t : !1;
}
re.inlineRef = Ha;
const Ga = /* @__PURE__ */ new Set([
  "$ref",
  "$recursiveRef",
  "$recursiveAnchor",
  "$dynamicRef",
  "$dynamicAnchor"
]);
function Qt(e) {
  for (const t in e) {
    if (Ga.has(t))
      return !0;
    const r = e[t];
    if (Array.isArray(r) && r.some(Qt) || typeof r == "object" && Qt(r))
      return !0;
  }
  return !1;
}
function Gn(e) {
  let t = 0;
  for (const r in e) {
    if (r === "$ref")
      return 1 / 0;
    if (t++, !La.has(r) && (typeof e[r] == "object" && (0, Ua.eachItem)(e[r], (n) => t += Gn(n)), t === 1 / 0))
      return 1 / 0;
  }
  return t;
}
function Jn(e, t = "", r) {
  r !== !1 && (t = Ve(t));
  const n = e.parse(t);
  return Bn(e, n);
}
re.getFullPath = Jn;
function Bn(e, t) {
  return e.serialize(t).split("#")[0] + "#";
}
re._getFullPath = Bn;
const Ja = /#\/?$/;
function Ve(e) {
  return e ? e.replace(Ja, "") : "";
}
re.normalizeId = Ve;
function Ba(e, t, r) {
  return r = Ve(r), e.resolve(t, r);
}
re.resolveUrl = Ba;
const Wa = /^[a-z_][-a-z0-9._]*$/i;
function Xa(e, t) {
  if (typeof e == "boolean")
    return {};
  const { schemaId: r, uriResolver: n } = this.opts, s = Ve(e[r] || t), a = { "": s }, i = Jn(n, s, !1), u = {}, d = /* @__PURE__ */ new Set();
  return Ka(e, { allKeys: !0 }, (p, N, w, v) => {
    if (v === void 0)
      return;
    const b = i + N;
    let $ = a[v];
    typeof p[r] == "string" && ($ = f.call(this, p[r])), _.call(this, p.$anchor), _.call(this, p.$dynamicAnchor), a[N] = $;
    function f(I) {
      const M = this.opts.uriResolver.resolve;
      if (I = Ve($ ? M($, I) : I), d.has(I))
        throw h(I);
      d.add(I);
      let F = this.refs[I];
      return typeof F == "string" && (F = this.refs[F]), typeof F == "object" ? c(p, F.schema, I) : I !== Ve(b) && (I[0] === "#" ? (c(p, u[I], I), u[I] = p) : this.refs[I] = b), I;
    }
    function _(I) {
      if (typeof I == "string") {
        if (!Wa.test(I))
          throw new Error(`invalid anchor "${I}"`);
        f.call(this, `#${I}`);
      }
    }
  }), u;
  function c(p, N, w) {
    if (N !== void 0 && !xa(p, N))
      throw h(w);
  }
  function h(p) {
    return new Error(`reference "${p}" resolves to more than one schema`);
  }
}
re.getSchemaRefs = Xa;
Object.defineProperty(fe, "__esModule", { value: !0 });
fe.getData = fe.KeywordCxt = fe.validateFunctionCode = void 0;
const Wn = qe, sn = Z, dr = ge, yt = Z, Ya = wt, We = me, Kt = Se, V = H, U = $e, Qa = re, _e = A, He = tt;
function Za(e) {
  if (Qn(e) && (Zn(e), Yn(e))) {
    ro(e);
    return;
  }
  Xn(e, () => (0, Wn.topBoolOrEmptySchema)(e));
}
fe.validateFunctionCode = Za;
function Xn({ gen: e, validateName: t, schema: r, schemaEnv: n, opts: s }, a) {
  s.code.es5 ? e.func(t, (0, V._)`${U.default.data}, ${U.default.valCxt}`, n.$async, () => {
    e.code((0, V._)`"use strict"; ${an(r, s)}`), to(e, s), e.code(a);
  }) : e.func(t, (0, V._)`${U.default.data}, ${eo(s)}`, n.$async, () => e.code(an(r, s)).code(a));
}
function eo(e) {
  return (0, V._)`{${U.default.instancePath}="", ${U.default.parentData}, ${U.default.parentDataProperty}, ${U.default.rootData}=${U.default.data}${e.dynamicRef ? (0, V._)`, ${U.default.dynamicAnchors}={}` : V.nil}}={}`;
}
function to(e, t) {
  e.if(U.default.valCxt, () => {
    e.var(U.default.instancePath, (0, V._)`${U.default.valCxt}.${U.default.instancePath}`), e.var(U.default.parentData, (0, V._)`${U.default.valCxt}.${U.default.parentData}`), e.var(U.default.parentDataProperty, (0, V._)`${U.default.valCxt}.${U.default.parentDataProperty}`), e.var(U.default.rootData, (0, V._)`${U.default.valCxt}.${U.default.rootData}`), t.dynamicRef && e.var(U.default.dynamicAnchors, (0, V._)`${U.default.valCxt}.${U.default.dynamicAnchors}`);
  }, () => {
    e.var(U.default.instancePath, (0, V._)`""`), e.var(U.default.parentData, (0, V._)`undefined`), e.var(U.default.parentDataProperty, (0, V._)`undefined`), e.var(U.default.rootData, U.default.data), t.dynamicRef && e.var(U.default.dynamicAnchors, (0, V._)`{}`);
  });
}
function ro(e) {
  const { schema: t, opts: r, gen: n } = e;
  Xn(e, () => {
    r.$comment && t.$comment && ts(e), io(e), n.let(U.default.vErrors, null), n.let(U.default.errors, 0), r.unevaluated && no(e), es(e), lo(e);
  });
}
function no(e) {
  const { gen: t, validateName: r } = e;
  e.evaluated = t.const("evaluated", (0, V._)`${r}.evaluated`), t.if((0, V._)`${e.evaluated}.dynamicProps`, () => t.assign((0, V._)`${e.evaluated}.props`, (0, V._)`undefined`)), t.if((0, V._)`${e.evaluated}.dynamicItems`, () => t.assign((0, V._)`${e.evaluated}.items`, (0, V._)`undefined`));
}
function an(e, t) {
  const r = typeof e == "object" && e[t.schemaId];
  return r && (t.code.source || t.code.process) ? (0, V._)`/*# sourceURL=${r} */` : V.nil;
}
function so(e, t) {
  if (Qn(e) && (Zn(e), Yn(e))) {
    ao(e, t);
    return;
  }
  (0, Wn.boolOrEmptySchema)(e, t);
}
function Yn({ schema: e, self: t }) {
  if (typeof e == "boolean")
    return !e;
  for (const r in e)
    if (t.RULES.all[r])
      return !0;
  return !1;
}
function Qn(e) {
  return typeof e.schema != "boolean";
}
function ao(e, t) {
  const { schema: r, gen: n, opts: s } = e;
  s.$comment && r.$comment && ts(e), co(e), uo(e);
  const a = n.const("_errs", U.default.errors);
  es(e, a), n.var(t, (0, V._)`${a} === ${U.default.errors}`);
}
function Zn(e) {
  (0, _e.checkUnknownRules)(e), oo(e);
}
function es(e, t) {
  if (e.opts.jtd)
    return on(e, [], !1, t);
  const r = (0, sn.getSchemaTypes)(e.schema), n = (0, sn.coerceAndCheckDataType)(e, r);
  on(e, r, !n, t);
}
function oo(e) {
  const { schema: t, errSchemaPath: r, opts: n, self: s } = e;
  t.$ref && n.ignoreKeywordsWithRef && (0, _e.schemaHasRulesButRef)(t, s.RULES) && s.logger.warn(`$ref: keywords ignored in schema at path "${r}"`);
}
function io(e) {
  const { schema: t, opts: r } = e;
  t.default !== void 0 && r.useDefaults && r.strictSchema && (0, _e.checkStrictMode)(e, "default is ignored in the schema root");
}
function co(e) {
  const t = e.schema[e.opts.schemaId];
  t && (e.baseId = (0, Qa.resolveUrl)(e.opts.uriResolver, e.baseId, t));
}
function uo(e) {
  if (e.schema.$async && !e.schemaEnv.$async)
    throw new Error("async schema in sync schema");
}
function ts({ gen: e, schemaEnv: t, schema: r, errSchemaPath: n, opts: s }) {
  const a = r.$comment;
  if (s.$comment === !0)
    e.code((0, V._)`${U.default.self}.logger.log(${a})`);
  else if (typeof s.$comment == "function") {
    const i = (0, V.str)`${n}/$comment`, u = e.scopeValue("root", { ref: t.root });
    e.code((0, V._)`${U.default.self}.opts.$comment(${a}, ${i}, ${u}.schema)`);
  }
}
function lo(e) {
  const { gen: t, schemaEnv: r, validateName: n, ValidationError: s, opts: a } = e;
  r.$async ? t.if((0, V._)`${U.default.errors} === 0`, () => t.return(U.default.data), () => t.throw((0, V._)`new ${s}(${U.default.vErrors})`)) : (t.assign((0, V._)`${n}.errors`, U.default.vErrors), a.unevaluated && fo(e), t.return((0, V._)`${U.default.errors} === 0`));
}
function fo({ gen: e, evaluated: t, props: r, items: n }) {
  r instanceof V.Name && e.assign((0, V._)`${t}.props`, r), n instanceof V.Name && e.assign((0, V._)`${t}.items`, n);
}
function on(e, t, r, n) {
  const { gen: s, schema: a, data: i, allErrors: u, opts: d, self: c } = e, { RULES: h } = c;
  if (a.$ref && (d.ignoreKeywordsWithRef || !(0, _e.schemaHasRulesButRef)(a, h))) {
    s.block(() => ss(e, "$ref", h.all.$ref.definition));
    return;
  }
  d.jtd || ho(e, t), s.block(() => {
    for (const N of h.rules)
      p(N);
    p(h.post);
  });
  function p(N) {
    (0, dr.shouldUseGroup)(a, N) && (N.type ? (s.if((0, yt.checkDataType)(N.type, i, d.strictNumbers)), cn(e, N), t.length === 1 && t[0] === N.type && r && (s.else(), (0, yt.reportTypeError)(e)), s.endIf()) : cn(e, N), u || s.if((0, V._)`${U.default.errors} === ${n || 0}`));
  }
}
function cn(e, t) {
  const { gen: r, schema: n, opts: { useDefaults: s } } = e;
  s && (0, Ya.assignDefaults)(e, t.type), r.block(() => {
    for (const a of t.rules)
      (0, dr.shouldUseRule)(n, a) && ss(e, a.keyword, a.definition, t.type);
  });
}
function ho(e, t) {
  e.schemaEnv.meta || !e.opts.strictTypes || (po(e, t), e.opts.allowUnionTypes || mo(e, t), yo(e, e.dataTypes));
}
function po(e, t) {
  if (t.length) {
    if (!e.dataTypes.length) {
      e.dataTypes = t;
      return;
    }
    t.forEach((r) => {
      rs(e.dataTypes, r) || fr(e, `type "${r}" not allowed by context "${e.dataTypes.join(",")}"`);
    }), go(e, t);
  }
}
function mo(e, t) {
  t.length > 1 && !(t.length === 2 && t.includes("null")) && fr(e, "use allowUnionTypes to allow union type keyword");
}
function yo(e, t) {
  const r = e.self.RULES.all;
  for (const n in r) {
    const s = r[n];
    if (typeof s == "object" && (0, dr.shouldUseRule)(e.schema, s)) {
      const { type: a } = s.definition;
      a.length && !a.some((i) => $o(t, i)) && fr(e, `missing type "${a.join(",")}" for keyword "${n}"`);
    }
  }
}
function $o(e, t) {
  return e.includes(t) || t === "number" && e.includes("integer");
}
function rs(e, t) {
  return e.includes(t) || t === "integer" && e.includes("number");
}
function go(e, t) {
  const r = [];
  for (const n of e.dataTypes)
    rs(t, n) ? r.push(n) : t.includes("integer") && n === "number" && r.push("integer");
  e.dataTypes = r;
}
function fr(e, t) {
  const r = e.schemaEnv.baseId + e.errSchemaPath;
  t += ` at "${r}" (strictTypes)`, (0, _e.checkStrictMode)(e, t, e.opts.strictTypes);
}
class ns {
  constructor(t, r, n) {
    if ((0, We.validateKeywordUsage)(t, r, n), this.gen = t.gen, this.allErrors = t.allErrors, this.keyword = n, this.data = t.data, this.schema = t.schema[n], this.$data = r.$data && t.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, _e.schemaRefOrVal)(t, this.schema, n, this.$data), this.schemaType = r.schemaType, this.parentSchema = t.schema, this.params = {}, this.it = t, this.def = r, this.$data)
      this.schemaCode = t.gen.const("vSchema", as(this.$data, t));
    else if (this.schemaCode = this.schemaValue, !(0, We.validSchemaType)(this.schema, r.schemaType, r.allowUndefined))
      throw new Error(`${n} value must be ${JSON.stringify(r.schemaType)}`);
    ("code" in r ? r.trackErrors : r.errors !== !1) && (this.errsCount = t.gen.const("_errs", U.default.errors));
  }
  result(t, r, n) {
    this.failResult((0, V.not)(t), r, n);
  }
  failResult(t, r, n) {
    this.gen.if(t), n ? n() : this.error(), r ? (this.gen.else(), r(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
  }
  pass(t, r) {
    this.failResult((0, V.not)(t), void 0, r);
  }
  fail(t) {
    if (t === void 0) {
      this.error(), this.allErrors || this.gen.if(!1);
      return;
    }
    this.gen.if(t), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
  }
  fail$data(t) {
    if (!this.$data)
      return this.fail(t);
    const { schemaCode: r } = this;
    this.fail((0, V._)`${r} !== undefined && (${(0, V.or)(this.invalid$data(), t)})`);
  }
  error(t, r, n) {
    if (r) {
      this.setParams(r), this._error(t, n), this.setParams({});
      return;
    }
    this._error(t, n);
  }
  _error(t, r) {
    (t ? He.reportExtraError : He.reportError)(this, this.def.error, r);
  }
  $dataError() {
    (0, He.reportError)(this, this.def.$dataError || He.keyword$DataError);
  }
  reset() {
    if (this.errsCount === void 0)
      throw new Error('add "trackErrors" to keyword definition');
    (0, He.resetErrorsCount)(this.gen, this.errsCount);
  }
  ok(t) {
    this.allErrors || this.gen.if(t);
  }
  setParams(t, r) {
    r ? Object.assign(this.params, t) : this.params = t;
  }
  block$data(t, r, n = V.nil) {
    this.gen.block(() => {
      this.check$data(t, n), r();
    });
  }
  check$data(t = V.nil, r = V.nil) {
    if (!this.$data)
      return;
    const { gen: n, schemaCode: s, schemaType: a, def: i } = this;
    n.if((0, V.or)((0, V._)`${s} === undefined`, r)), t !== V.nil && n.assign(t, !0), (a.length || i.validateSchema) && (n.elseIf(this.invalid$data()), this.$dataError(), t !== V.nil && n.assign(t, !1)), n.else();
  }
  invalid$data() {
    const { gen: t, schemaCode: r, schemaType: n, def: s, it: a } = this;
    return (0, V.or)(i(), u());
    function i() {
      if (n.length) {
        if (!(r instanceof V.Name))
          throw new Error("ajv implementation error");
        const d = Array.isArray(n) ? n : [n];
        return (0, V._)`${(0, yt.checkDataTypes)(d, r, a.opts.strictNumbers, yt.DataType.Wrong)}`;
      }
      return V.nil;
    }
    function u() {
      if (s.validateSchema) {
        const d = t.scopeValue("validate$data", { ref: s.validateSchema });
        return (0, V._)`!${d}(${r})`;
      }
      return V.nil;
    }
  }
  subschema(t, r) {
    const n = (0, Kt.getSubschema)(this.it, t);
    (0, Kt.extendSubschemaData)(n, this.it, t), (0, Kt.extendSubschemaMode)(n, t);
    const s = { ...this.it, ...n, items: void 0, props: void 0 };
    return so(s, r), s;
  }
  mergeEvaluated(t, r) {
    const { it: n, gen: s } = this;
    n.opts.unevaluated && (n.props !== !0 && t.props !== void 0 && (n.props = _e.mergeEvaluated.props(s, t.props, n.props, r)), n.items !== !0 && t.items !== void 0 && (n.items = _e.mergeEvaluated.items(s, t.items, n.items, r)));
  }
  mergeValidEvaluated(t, r) {
    const { it: n, gen: s } = this;
    if (n.opts.unevaluated && (n.props !== !0 || n.items !== !0))
      return s.if(r, () => this.mergeEvaluated(t, V.Name)), !0;
  }
}
fe.KeywordCxt = ns;
function ss(e, t, r, n) {
  const s = new ns(e, r, t);
  "code" in r ? r.code(s, n) : s.$data && r.validate ? (0, We.funcKeywordCode)(s, r) : "macro" in r ? (0, We.macroKeywordCode)(s, r) : (r.compile || r.validate) && (0, We.funcKeywordCode)(s, r);
}
const _o = /^\/(?:[^~]|~0|~1)*$/, vo = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function as(e, { dataLevel: t, dataNames: r, dataPathArr: n }) {
  let s, a;
  if (e === "")
    return U.default.rootData;
  if (e[0] === "/") {
    if (!_o.test(e))
      throw new Error(`Invalid JSON-pointer: ${e}`);
    s = e, a = U.default.rootData;
  } else {
    const c = vo.exec(e);
    if (!c)
      throw new Error(`Invalid JSON-pointer: ${e}`);
    const h = +c[1];
    if (s = c[2], s === "#") {
      if (h >= t)
        throw new Error(d("property/index", h));
      return n[t - h];
    }
    if (h > t)
      throw new Error(d("data", h));
    if (a = r[t - h], !s)
      return a;
  }
  let i = a;
  const u = s.split("/");
  for (const c of u)
    c && (a = (0, V._)`${a}${(0, V.getProperty)((0, _e.unescapeJsonPointer)(c))}`, i = (0, V._)`${i} && ${a}`);
  return i;
  function d(c, h) {
    return `Cannot access ${c} ${h} levels up, current level is ${t}`;
  }
}
fe.getData = as;
var rt = {};
Object.defineProperty(rt, "__esModule", { value: !0 });
class wo extends Error {
  constructor(t) {
    super("validation failed"), this.errors = t, this.ajv = this.validation = !0;
  }
}
rt.default = wo;
var Ue = {};
Object.defineProperty(Ue, "__esModule", { value: !0 });
const Lt = re;
class bo extends Error {
  constructor(t, r, n, s) {
    super(s || `can't resolve reference ${n} from id ${r}`), this.missingRef = (0, Lt.resolveUrl)(t, r, n), this.missingSchema = (0, Lt.normalizeId)((0, Lt.getFullPath)(t, this.missingRef));
  }
}
Ue.default = bo;
var ie = {};
Object.defineProperty(ie, "__esModule", { value: !0 });
ie.resolveSchema = ie.getCompilingSchema = ie.resolveRef = ie.compileSchema = ie.SchemaEnv = void 0;
const ue = H, Eo = rt, Ne = $e, de = re, un = A, So = fe;
class bt {
  constructor(t) {
    var r;
    this.refs = {}, this.dynamicAnchors = {};
    let n;
    typeof t.schema == "object" && (n = t.schema), this.schema = t.schema, this.schemaId = t.schemaId, this.root = t.root || this, this.baseId = (r = t.baseId) !== null && r !== void 0 ? r : (0, de.normalizeId)(n?.[t.schemaId || "$id"]), this.schemaPath = t.schemaPath, this.localRefs = t.localRefs, this.meta = t.meta, this.$async = n?.$async, this.refs = {};
  }
}
ie.SchemaEnv = bt;
function hr(e) {
  const t = os.call(this, e);
  if (t)
    return t;
  const r = (0, de.getFullPath)(this.opts.uriResolver, e.root.baseId), { es5: n, lines: s } = this.opts.code, { ownProperties: a } = this.opts, i = new ue.CodeGen(this.scope, { es5: n, lines: s, ownProperties: a });
  let u;
  e.$async && (u = i.scopeValue("Error", {
    ref: Eo.default,
    code: (0, ue._)`require("ajv/dist/runtime/validation_error").default`
  }));
  const d = i.scopeName("validate");
  e.validateName = d;
  const c = {
    gen: i,
    allErrors: this.opts.allErrors,
    data: Ne.default.data,
    parentData: Ne.default.parentData,
    parentDataProperty: Ne.default.parentDataProperty,
    dataNames: [Ne.default.data],
    dataPathArr: [ue.nil],
    // TODO can its length be used as dataLevel if nil is removed?
    dataLevel: 0,
    dataTypes: [],
    definedProperties: /* @__PURE__ */ new Set(),
    topSchemaRef: i.scopeValue("schema", this.opts.code.source === !0 ? { ref: e.schema, code: (0, ue.stringify)(e.schema) } : { ref: e.schema }),
    validateName: d,
    ValidationError: u,
    schema: e.schema,
    schemaEnv: e,
    rootId: r,
    baseId: e.baseId || r,
    schemaPath: ue.nil,
    errSchemaPath: e.schemaPath || (this.opts.jtd ? "" : "#"),
    errorPath: (0, ue._)`""`,
    opts: this.opts,
    self: this
  };
  let h;
  try {
    this._compilations.add(e), (0, So.validateFunctionCode)(c), i.optimize(this.opts.code.optimize);
    const p = i.toString();
    h = `${i.scopeRefs(Ne.default.scope)}return ${p}`, this.opts.code.process && (h = this.opts.code.process(h, e));
    const w = new Function(`${Ne.default.self}`, `${Ne.default.scope}`, h)(this, this.scope.get());
    if (this.scope.value(d, { ref: w }), w.errors = null, w.schema = e.schema, w.schemaEnv = e, e.$async && (w.$async = !0), this.opts.code.source === !0 && (w.source = { validateName: d, validateCode: p, scopeValues: i._values }), this.opts.unevaluated) {
      const { props: v, items: b } = c;
      w.evaluated = {
        props: v instanceof ue.Name ? void 0 : v,
        items: b instanceof ue.Name ? void 0 : b,
        dynamicProps: v instanceof ue.Name,
        dynamicItems: b instanceof ue.Name
      }, w.source && (w.source.evaluated = (0, ue.stringify)(w.evaluated));
    }
    return e.validate = w, e;
  } catch (p) {
    throw delete e.validate, delete e.validateName, h && this.logger.error("Error compiling schema, function code:", h), p;
  } finally {
    this._compilations.delete(e);
  }
}
ie.compileSchema = hr;
function Po(e, t, r) {
  var n;
  r = (0, de.resolveUrl)(this.opts.uriResolver, t, r);
  const s = e.refs[r];
  if (s)
    return s;
  let a = ko.call(this, e, r);
  if (a === void 0) {
    const i = (n = e.localRefs) === null || n === void 0 ? void 0 : n[r], { schemaId: u } = this.opts;
    i && (a = new bt({ schema: i, schemaId: u, root: e, baseId: t }));
  }
  if (a !== void 0)
    return e.refs[r] = No.call(this, a);
}
ie.resolveRef = Po;
function No(e) {
  return (0, de.inlineRef)(e.schema, this.opts.inlineRefs) ? e.schema : e.validate ? e : hr.call(this, e);
}
function os(e) {
  for (const t of this._compilations)
    if (Ro(t, e))
      return t;
}
ie.getCompilingSchema = os;
function Ro(e, t) {
  return e.schema === t.schema && e.root === t.root && e.baseId === t.baseId;
}
function ko(e, t) {
  let r;
  for (; typeof (r = this.refs[t]) == "string"; )
    t = r;
  return r || this.schemas[t] || Et.call(this, e, t);
}
function Et(e, t) {
  const r = this.opts.uriResolver.parse(t), n = (0, de._getFullPath)(this.opts.uriResolver, r);
  let s = (0, de.getFullPath)(this.opts.uriResolver, e.baseId, void 0);
  if (Object.keys(e.schema).length > 0 && n === s)
    return Ht.call(this, r, e);
  const a = (0, de.normalizeId)(n), i = this.refs[a] || this.schemas[a];
  if (typeof i == "string") {
    const u = Et.call(this, e, i);
    return typeof u?.schema != "object" ? void 0 : Ht.call(this, r, u);
  }
  if (typeof i?.schema == "object") {
    if (i.validate || hr.call(this, i), a === (0, de.normalizeId)(t)) {
      const { schema: u } = i, { schemaId: d } = this.opts, c = u[d];
      return c && (s = (0, de.resolveUrl)(this.opts.uriResolver, s, c)), new bt({ schema: u, schemaId: d, root: e, baseId: s });
    }
    return Ht.call(this, r, i);
  }
}
ie.resolveSchema = Et;
const Oo = /* @__PURE__ */ new Set([
  "properties",
  "patternProperties",
  "enum",
  "dependencies",
  "definitions"
]);
function Ht(e, { baseId: t, schema: r, root: n }) {
  var s;
  if (((s = e.fragment) === null || s === void 0 ? void 0 : s[0]) !== "/")
    return;
  for (const u of e.fragment.slice(1).split("/")) {
    if (typeof r == "boolean")
      return;
    const d = r[(0, un.unescapeFragment)(u)];
    if (d === void 0)
      return;
    r = d;
    const c = typeof r == "object" && r[this.opts.schemaId];
    !Oo.has(u) && c && (t = (0, de.resolveUrl)(this.opts.uriResolver, t, c));
  }
  let a;
  if (typeof r != "boolean" && r.$ref && !(0, un.schemaHasRulesButRef)(r, this.RULES)) {
    const u = (0, de.resolveUrl)(this.opts.uriResolver, t, r.$ref);
    a = Et.call(this, n, u);
  }
  const { schemaId: i } = this.opts;
  if (a = a || new bt({ schema: r, schemaId: i, root: n, baseId: t }), a.schema !== a.root.schema)
    return a;
}
const jo = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", To = "Meta-schema for $data reference (JSON AnySchema extension proposal)", Io = "object", Co = [
  "$data"
], Ao = {
  $data: {
    type: "string",
    anyOf: [
      {
        format: "relative-json-pointer"
      },
      {
        format: "json-pointer"
      }
    ]
  }
}, Mo = !1, Fo = {
  $id: jo,
  description: To,
  type: Io,
  required: Co,
  properties: Ao,
  additionalProperties: Mo
};
var pr = {}, St = { exports: {} };
const Do = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
var Vo = {
  HEX: Do
};
const { HEX: qo } = Vo;
function is(e) {
  if (us(e, ".") < 3)
    return { host: e, isIPV4: !1 };
  const t = e.match(/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/u) || [], [r] = t;
  return r ? { host: Uo(r, "."), isIPV4: !0 } : { host: e, isIPV4: !1 };
}
function Zt(e, t = !1) {
  let r = "", n = !0;
  for (const s of e) {
    if (qo[s] === void 0) return;
    s !== "0" && n === !0 && (n = !1), n || (r += s);
  }
  return t && r.length === 0 && (r = "0"), r;
}
function zo(e) {
  let t = 0;
  const r = { error: !1, address: "", zone: "" }, n = [], s = [];
  let a = !1, i = !1, u = !1;
  function d() {
    if (s.length) {
      if (a === !1) {
        const c = Zt(s);
        if (c !== void 0)
          n.push(c);
        else
          return r.error = !0, !1;
      }
      s.length = 0;
    }
    return !0;
  }
  for (let c = 0; c < e.length; c++) {
    const h = e[c];
    if (!(h === "[" || h === "]"))
      if (h === ":") {
        if (i === !0 && (u = !0), !d())
          break;
        if (t++, n.push(":"), t > 7) {
          r.error = !0;
          break;
        }
        c - 1 >= 0 && e[c - 1] === ":" && (i = !0);
        continue;
      } else if (h === "%") {
        if (!d())
          break;
        a = !0;
      } else {
        s.push(h);
        continue;
      }
  }
  return s.length && (a ? r.zone = s.join("") : u ? n.push(s.join("")) : n.push(Zt(s))), r.address = n.join(""), r;
}
function cs(e, t = {}) {
  if (us(e, ":") < 2)
    return { host: e, isIPV6: !1 };
  const r = zo(e);
  if (r.error)
    return { host: e, isIPV6: !1 };
  {
    let n = r.address, s = r.address;
    return r.zone && (n += "%" + r.zone, s += "%25" + r.zone), { host: n, escapedHost: s, isIPV6: !0 };
  }
}
function Uo(e, t) {
  let r = "", n = !0;
  const s = e.length;
  for (let a = 0; a < s; a++) {
    const i = e[a];
    i === "0" && n ? (a + 1 <= s && e[a + 1] === t || a + 1 === s) && (r += i, n = !1) : (i === t ? n = !0 : n = !1, r += i);
  }
  return r;
}
function us(e, t) {
  let r = 0;
  for (let n = 0; n < e.length; n++)
    e[n] === t && r++;
  return r;
}
const ln = /^\.\.?\//u, dn = /^\/\.(?:\/|$)/u, fn = /^\/\.\.(?:\/|$)/u, xo = /^\/?(?:.|\n)*?(?=\/|$)/u;
function Ko(e) {
  const t = [];
  for (; e.length; )
    if (e.match(ln))
      e = e.replace(ln, "");
    else if (e.match(dn))
      e = e.replace(dn, "/");
    else if (e.match(fn))
      e = e.replace(fn, "/"), t.pop();
    else if (e === "." || e === "..")
      e = "";
    else {
      const r = e.match(xo);
      if (r) {
        const n = r[0];
        e = e.slice(n.length), t.push(n);
      } else
        throw new Error("Unexpected dot segment condition");
    }
  return t.join("");
}
function Lo(e, t) {
  const r = t !== !0 ? escape : unescape;
  return e.scheme !== void 0 && (e.scheme = r(e.scheme)), e.userinfo !== void 0 && (e.userinfo = r(e.userinfo)), e.host !== void 0 && (e.host = r(e.host)), e.path !== void 0 && (e.path = r(e.path)), e.query !== void 0 && (e.query = r(e.query)), e.fragment !== void 0 && (e.fragment = r(e.fragment)), e;
}
function Ho(e, t) {
  const r = [];
  if (e.userinfo !== void 0 && (r.push(e.userinfo), r.push("@")), e.host !== void 0) {
    let n = unescape(e.host);
    const s = is(n);
    if (s.isIPV4)
      n = s.host;
    else {
      const a = cs(s.host, { isIPV4: !1 });
      a.isIPV6 === !0 ? n = `[${a.escapedHost}]` : n = e.host;
    }
    r.push(n);
  }
  return (typeof e.port == "number" || typeof e.port == "string") && (r.push(":"), r.push(String(e.port))), r.length ? r.join("") : void 0;
}
var Go = {
  recomposeAuthority: Ho,
  normalizeComponentEncoding: Lo,
  removeDotSegments: Ko,
  normalizeIPv4: is,
  normalizeIPv6: cs,
  stringArrayToHexStripped: Zt
};
const Jo = /^[\da-f]{8}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{12}$/iu, Bo = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
function ls(e) {
  return typeof e.secure == "boolean" ? e.secure : String(e.scheme).toLowerCase() === "wss";
}
function ds(e) {
  return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
}
function fs(e) {
  const t = String(e.scheme).toLowerCase() === "https";
  return (e.port === (t ? 443 : 80) || e.port === "") && (e.port = void 0), e.path || (e.path = "/"), e;
}
function Wo(e) {
  return e.secure = ls(e), e.resourceName = (e.path || "/") + (e.query ? "?" + e.query : ""), e.path = void 0, e.query = void 0, e;
}
function Xo(e) {
  if ((e.port === (ls(e) ? 443 : 80) || e.port === "") && (e.port = void 0), typeof e.secure == "boolean" && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName) {
    const [t, r] = e.resourceName.split("?");
    e.path = t && t !== "/" ? t : void 0, e.query = r, e.resourceName = void 0;
  }
  return e.fragment = void 0, e;
}
function Yo(e, t) {
  if (!e.path)
    return e.error = "URN can not be parsed", e;
  const r = e.path.match(Bo);
  if (r) {
    const n = t.scheme || e.scheme || "urn";
    e.nid = r[1].toLowerCase(), e.nss = r[2];
    const s = `${n}:${t.nid || e.nid}`, a = mr[s];
    e.path = void 0, a && (e = a.parse(e, t));
  } else
    e.error = e.error || "URN can not be parsed.";
  return e;
}
function Qo(e, t) {
  const r = t.scheme || e.scheme || "urn", n = e.nid.toLowerCase(), s = `${r}:${t.nid || n}`, a = mr[s];
  a && (e = a.serialize(e, t));
  const i = e, u = e.nss;
  return i.path = `${n || t.nid}:${u}`, t.skipEscape = !0, i;
}
function Zo(e, t) {
  const r = e;
  return r.uuid = r.nss, r.nss = void 0, !t.tolerant && (!r.uuid || !Jo.test(r.uuid)) && (r.error = r.error || "UUID is not valid."), r;
}
function ei(e) {
  const t = e;
  return t.nss = (e.uuid || "").toLowerCase(), t;
}
const hs = {
  scheme: "http",
  domainHost: !0,
  parse: ds,
  serialize: fs
}, ti = {
  scheme: "https",
  domainHost: hs.domainHost,
  parse: ds,
  serialize: fs
}, ft = {
  scheme: "ws",
  domainHost: !0,
  parse: Wo,
  serialize: Xo
}, ri = {
  scheme: "wss",
  domainHost: ft.domainHost,
  parse: ft.parse,
  serialize: ft.serialize
}, ni = {
  scheme: "urn",
  parse: Yo,
  serialize: Qo,
  skipNormalize: !0
}, si = {
  scheme: "urn:uuid",
  parse: Zo,
  serialize: ei,
  skipNormalize: !0
}, mr = {
  http: hs,
  https: ti,
  ws: ft,
  wss: ri,
  urn: ni,
  "urn:uuid": si
};
var ai = mr;
const { normalizeIPv6: oi, normalizeIPv4: ii, removeDotSegments: Je, recomposeAuthority: ci, normalizeComponentEncoding: at } = Go, yr = ai;
function ui(e, t) {
  return typeof e == "string" ? e = ye(ve(e, t), t) : typeof e == "object" && (e = ve(ye(e, t), t)), e;
}
function li(e, t, r) {
  const n = Object.assign({ scheme: "null" }, r), s = ps(ve(e, n), ve(t, n), n, !0);
  return ye(s, { ...n, skipEscape: !0 });
}
function ps(e, t, r, n) {
  const s = {};
  return n || (e = ve(ye(e, r), r), t = ve(ye(t, r), r)), r = r || {}, !r.tolerant && t.scheme ? (s.scheme = t.scheme, s.userinfo = t.userinfo, s.host = t.host, s.port = t.port, s.path = Je(t.path || ""), s.query = t.query) : (t.userinfo !== void 0 || t.host !== void 0 || t.port !== void 0 ? (s.userinfo = t.userinfo, s.host = t.host, s.port = t.port, s.path = Je(t.path || ""), s.query = t.query) : (t.path ? (t.path.charAt(0) === "/" ? s.path = Je(t.path) : ((e.userinfo !== void 0 || e.host !== void 0 || e.port !== void 0) && !e.path ? s.path = "/" + t.path : e.path ? s.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : s.path = t.path, s.path = Je(s.path)), s.query = t.query) : (s.path = e.path, t.query !== void 0 ? s.query = t.query : s.query = e.query), s.userinfo = e.userinfo, s.host = e.host, s.port = e.port), s.scheme = e.scheme), s.fragment = t.fragment, s;
}
function di(e, t, r) {
  return typeof e == "string" ? (e = unescape(e), e = ye(at(ve(e, r), !0), { ...r, skipEscape: !0 })) : typeof e == "object" && (e = ye(at(e, !0), { ...r, skipEscape: !0 })), typeof t == "string" ? (t = unescape(t), t = ye(at(ve(t, r), !0), { ...r, skipEscape: !0 })) : typeof t == "object" && (t = ye(at(t, !0), { ...r, skipEscape: !0 })), e.toLowerCase() === t.toLowerCase();
}
function ye(e, t) {
  const r = {
    host: e.host,
    scheme: e.scheme,
    userinfo: e.userinfo,
    port: e.port,
    path: e.path,
    query: e.query,
    nid: e.nid,
    nss: e.nss,
    uuid: e.uuid,
    fragment: e.fragment,
    reference: e.reference,
    resourceName: e.resourceName,
    secure: e.secure,
    error: ""
  }, n = Object.assign({}, t), s = [], a = yr[(n.scheme || r.scheme || "").toLowerCase()];
  a && a.serialize && a.serialize(r, n), r.path !== void 0 && (n.skipEscape ? r.path = unescape(r.path) : (r.path = escape(r.path), r.scheme !== void 0 && (r.path = r.path.split("%3A").join(":")))), n.reference !== "suffix" && r.scheme && (s.push(r.scheme), s.push(":"));
  const i = ci(r, n);
  if (i !== void 0 && (n.reference !== "suffix" && s.push("//"), s.push(i), r.path && r.path.charAt(0) !== "/" && s.push("/")), r.path !== void 0) {
    let u = r.path;
    !n.absolutePath && (!a || !a.absolutePath) && (u = Je(u)), i === void 0 && (u = u.replace(/^\/\//u, "/%2F")), s.push(u);
  }
  return r.query !== void 0 && (s.push("?"), s.push(r.query)), r.fragment !== void 0 && (s.push("#"), s.push(r.fragment)), s.join("");
}
const fi = Array.from({ length: 127 }, (e, t) => /[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(t)));
function hi(e) {
  let t = 0;
  for (let r = 0, n = e.length; r < n; ++r)
    if (t = e.charCodeAt(r), t > 126 || fi[t])
      return !0;
  return !1;
}
const pi = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
function ve(e, t) {
  const r = Object.assign({}, t), n = {
    scheme: void 0,
    userinfo: void 0,
    host: "",
    port: void 0,
    path: "",
    query: void 0,
    fragment: void 0
  }, s = e.indexOf("%") !== -1;
  let a = !1;
  r.reference === "suffix" && (e = (r.scheme ? r.scheme + ":" : "") + "//" + e);
  const i = e.match(pi);
  if (i) {
    if (n.scheme = i[1], n.userinfo = i[3], n.host = i[4], n.port = parseInt(i[5], 10), n.path = i[6] || "", n.query = i[7], n.fragment = i[8], isNaN(n.port) && (n.port = i[5]), n.host) {
      const d = ii(n.host);
      if (d.isIPV4 === !1) {
        const c = oi(d.host, { isIPV4: !1 });
        n.host = c.host.toLowerCase(), a = c.isIPV6;
      } else
        n.host = d.host, a = !0;
    }
    n.scheme === void 0 && n.userinfo === void 0 && n.host === void 0 && n.port === void 0 && !n.path && n.query === void 0 ? n.reference = "same-document" : n.scheme === void 0 ? n.reference = "relative" : n.fragment === void 0 ? n.reference = "absolute" : n.reference = "uri", r.reference && r.reference !== "suffix" && r.reference !== n.reference && (n.error = n.error || "URI is not a " + r.reference + " reference.");
    const u = yr[(r.scheme || n.scheme || "").toLowerCase()];
    if (!r.unicodeSupport && (!u || !u.unicodeSupport) && n.host && (r.domainHost || u && u.domainHost) && a === !1 && hi(n.host))
      try {
        n.host = URL.domainToASCII(n.host.toLowerCase());
      } catch (d) {
        n.error = n.error || "Host's domain name can not be converted to ASCII: " + d;
      }
    (!u || u && !u.skipNormalize) && (s && n.scheme !== void 0 && (n.scheme = unescape(n.scheme)), s && n.userinfo !== void 0 && (n.userinfo = unescape(n.userinfo)), s && n.host !== void 0 && (n.host = unescape(n.host)), n.path !== void 0 && n.path.length && (n.path = escape(unescape(n.path))), n.fragment !== void 0 && n.fragment.length && (n.fragment = encodeURI(decodeURIComponent(n.fragment)))), u && u.parse && u.parse(n, r);
  } else
    n.error = n.error || "URI can not be parsed.";
  return n;
}
const $r = {
  SCHEMES: yr,
  normalize: ui,
  resolve: li,
  resolveComponents: ps,
  equal: di,
  serialize: ye,
  parse: ve
};
St.exports = $r;
St.exports.default = $r;
St.exports.fastUri = $r;
var mi = St.exports;
Object.defineProperty(pr, "__esModule", { value: !0 });
const ms = mi;
ms.code = 'require("ajv/dist/runtime/uri").default';
pr.default = ms;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CodeGen = e.Name = e.nil = e.stringify = e.str = e._ = e.KeywordCxt = void 0;
  var t = fe;
  Object.defineProperty(e, "KeywordCxt", { enumerable: !0, get: function() {
    return t.KeywordCxt;
  } });
  var r = H;
  Object.defineProperty(e, "_", { enumerable: !0, get: function() {
    return r._;
  } }), Object.defineProperty(e, "str", { enumerable: !0, get: function() {
    return r.str;
  } }), Object.defineProperty(e, "stringify", { enumerable: !0, get: function() {
    return r.stringify;
  } }), Object.defineProperty(e, "nil", { enumerable: !0, get: function() {
    return r.nil;
  } }), Object.defineProperty(e, "Name", { enumerable: !0, get: function() {
    return r.Name;
  } }), Object.defineProperty(e, "CodeGen", { enumerable: !0, get: function() {
    return r.CodeGen;
  } });
  const n = rt, s = Ue, a = je, i = ie, u = H, d = re, c = Z, h = A, p = Fo, N = pr, w = (C, y) => new RegExp(C, y);
  w.code = "new RegExp";
  const v = ["removeAdditional", "useDefaults", "coerceTypes"], b = /* @__PURE__ */ new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
  ]), $ = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
  }, f = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
  }, _ = 200;
  function I(C) {
    var y, k, g, o, l, E, q, z, B, J, ee, Ce, kt, Ot, jt, Tt, It, Ct, At, Mt, Ft, Dt, Vt, qt, zt;
    const Le = C.strict, Ut = (y = C.code) === null || y === void 0 ? void 0 : y.optimize, Yr = Ut === !0 || Ut === void 0 ? 1 : Ut || 0, Qr = (g = (k = C.code) === null || k === void 0 ? void 0 : k.regExp) !== null && g !== void 0 ? g : w, Ns = (o = C.uriResolver) !== null && o !== void 0 ? o : N.default;
    return {
      strictSchema: (E = (l = C.strictSchema) !== null && l !== void 0 ? l : Le) !== null && E !== void 0 ? E : !0,
      strictNumbers: (z = (q = C.strictNumbers) !== null && q !== void 0 ? q : Le) !== null && z !== void 0 ? z : !0,
      strictTypes: (J = (B = C.strictTypes) !== null && B !== void 0 ? B : Le) !== null && J !== void 0 ? J : "log",
      strictTuples: (Ce = (ee = C.strictTuples) !== null && ee !== void 0 ? ee : Le) !== null && Ce !== void 0 ? Ce : "log",
      strictRequired: (Ot = (kt = C.strictRequired) !== null && kt !== void 0 ? kt : Le) !== null && Ot !== void 0 ? Ot : !1,
      code: C.code ? { ...C.code, optimize: Yr, regExp: Qr } : { optimize: Yr, regExp: Qr },
      loopRequired: (jt = C.loopRequired) !== null && jt !== void 0 ? jt : _,
      loopEnum: (Tt = C.loopEnum) !== null && Tt !== void 0 ? Tt : _,
      meta: (It = C.meta) !== null && It !== void 0 ? It : !0,
      messages: (Ct = C.messages) !== null && Ct !== void 0 ? Ct : !0,
      inlineRefs: (At = C.inlineRefs) !== null && At !== void 0 ? At : !0,
      schemaId: (Mt = C.schemaId) !== null && Mt !== void 0 ? Mt : "$id",
      addUsedSchema: (Ft = C.addUsedSchema) !== null && Ft !== void 0 ? Ft : !0,
      validateSchema: (Dt = C.validateSchema) !== null && Dt !== void 0 ? Dt : !0,
      validateFormats: (Vt = C.validateFormats) !== null && Vt !== void 0 ? Vt : !0,
      unicodeRegExp: (qt = C.unicodeRegExp) !== null && qt !== void 0 ? qt : !0,
      int32range: (zt = C.int32range) !== null && zt !== void 0 ? zt : !0,
      uriResolver: Ns
    };
  }
  class M {
    constructor(y = {}) {
      this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = /* @__PURE__ */ new Set(), this._loading = {}, this._cache = /* @__PURE__ */ new Map(), y = this.opts = { ...y, ...I(y) };
      const { es5: k, lines: g } = this.opts.code;
      this.scope = new u.ValueScope({ scope: {}, prefixes: b, es5: k, lines: g }), this.logger = P(y.logger);
      const o = y.validateFormats;
      y.validateFormats = !1, this.RULES = (0, a.getRules)(), F.call(this, $, y, "NOT SUPPORTED"), F.call(this, f, y, "DEPRECATED", "warn"), this._metaOpts = S.call(this), y.formats && se.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), y.keywords && m.call(this, y.keywords), typeof y.meta == "object" && this.addMetaSchema(y.meta), Y.call(this), y.validateFormats = o;
    }
    _addVocabularies() {
      this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
      const { $data: y, meta: k, schemaId: g } = this.opts;
      let o = p;
      g === "id" && (o = { ...p }, o.id = o.$id, delete o.$id), k && y && this.addMetaSchema(o, o[g], !1);
    }
    defaultMeta() {
      const { meta: y, schemaId: k } = this.opts;
      return this.opts.defaultMeta = typeof y == "object" ? y[k] || y : void 0;
    }
    validate(y, k) {
      let g;
      if (typeof y == "string") {
        if (g = this.getSchema(y), !g)
          throw new Error(`no schema with key or ref "${y}"`);
      } else
        g = this.compile(y);
      const o = g(k);
      return "$async" in g || (this.errors = g.errors), o;
    }
    compile(y, k) {
      const g = this._addSchema(y, k);
      return g.validate || this._compileSchemaEnv(g);
    }
    compileAsync(y, k) {
      if (typeof this.opts.loadSchema != "function")
        throw new Error("options.loadSchema should be a function");
      const { loadSchema: g } = this.opts;
      return o.call(this, y, k);
      async function o(J, ee) {
        await l.call(this, J.$schema);
        const Ce = this._addSchema(J, ee);
        return Ce.validate || E.call(this, Ce);
      }
      async function l(J) {
        J && !this.getSchema(J) && await o.call(this, { $ref: J }, !0);
      }
      async function E(J) {
        try {
          return this._compileSchemaEnv(J);
        } catch (ee) {
          if (!(ee instanceof s.default))
            throw ee;
          return q.call(this, ee), await z.call(this, ee.missingSchema), E.call(this, J);
        }
      }
      function q({ missingSchema: J, missingRef: ee }) {
        if (this.refs[J])
          throw new Error(`AnySchema ${J} is loaded but ${ee} cannot be resolved`);
      }
      async function z(J) {
        const ee = await B.call(this, J);
        this.refs[J] || await l.call(this, ee.$schema), this.refs[J] || this.addSchema(ee, J, k);
      }
      async function B(J) {
        const ee = this._loading[J];
        if (ee)
          return ee;
        try {
          return await (this._loading[J] = g(J));
        } finally {
          delete this._loading[J];
        }
      }
    }
    // Adds schema to the instance
    addSchema(y, k, g, o = this.opts.validateSchema) {
      if (Array.isArray(y)) {
        for (const E of y)
          this.addSchema(E, void 0, g, o);
        return this;
      }
      let l;
      if (typeof y == "object") {
        const { schemaId: E } = this.opts;
        if (l = y[E], l !== void 0 && typeof l != "string")
          throw new Error(`schema ${E} must be string`);
      }
      return k = (0, d.normalizeId)(k || l), this._checkUnique(k), this.schemas[k] = this._addSchema(y, g, k, o, !0), this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(y, k, g = this.opts.validateSchema) {
      return this.addSchema(y, k, !0, g), this;
    }
    //  Validate schema against its meta-schema
    validateSchema(y, k) {
      if (typeof y == "boolean")
        return !0;
      let g;
      if (g = y.$schema, g !== void 0 && typeof g != "string")
        throw new Error("$schema must be a string");
      if (g = g || this.opts.defaultMeta || this.defaultMeta(), !g)
        return this.logger.warn("meta-schema not available"), this.errors = null, !0;
      const o = this.validate(g, y);
      if (!o && k) {
        const l = "schema is invalid: " + this.errorsText();
        if (this.opts.validateSchema === "log")
          this.logger.error(l);
        else
          throw new Error(l);
      }
      return o;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(y) {
      let k;
      for (; typeof (k = x.call(this, y)) == "string"; )
        y = k;
      if (k === void 0) {
        const { schemaId: g } = this.opts, o = new i.SchemaEnv({ schema: {}, schemaId: g });
        if (k = i.resolveSchema.call(this, o, y), !k)
          return;
        this.refs[y] = k;
      }
      return k.validate || this._compileSchemaEnv(k);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(y) {
      if (y instanceof RegExp)
        return this._removeAllSchemas(this.schemas, y), this._removeAllSchemas(this.refs, y), this;
      switch (typeof y) {
        case "undefined":
          return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
        case "string": {
          const k = x.call(this, y);
          return typeof k == "object" && this._cache.delete(k.schema), delete this.schemas[y], delete this.refs[y], this;
        }
        case "object": {
          const k = y;
          this._cache.delete(k);
          let g = y[this.opts.schemaId];
          return g && (g = (0, d.normalizeId)(g), delete this.schemas[g], delete this.refs[g]), this;
        }
        default:
          throw new Error("ajv.removeSchema: invalid parameter");
      }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(y) {
      for (const k of y)
        this.addKeyword(k);
      return this;
    }
    addKeyword(y, k) {
      let g;
      if (typeof y == "string")
        g = y, typeof k == "object" && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), k.keyword = g);
      else if (typeof y == "object" && k === void 0) {
        if (k = y, g = k.keyword, Array.isArray(g) && !g.length)
          throw new Error("addKeywords: keyword must be string or non-empty array");
      } else
        throw new Error("invalid addKeywords parameters");
      if (R.call(this, g, k), !k)
        return (0, h.eachItem)(g, (l) => D.call(this, l)), this;
      G.call(this, k);
      const o = {
        ...k,
        type: (0, c.getJSONTypes)(k.type),
        schemaType: (0, c.getJSONTypes)(k.schemaType)
      };
      return (0, h.eachItem)(g, o.type.length === 0 ? (l) => D.call(this, l, o) : (l) => o.type.forEach((E) => D.call(this, l, o, E))), this;
    }
    getKeyword(y) {
      const k = this.RULES.all[y];
      return typeof k == "object" ? k.definition : !!k;
    }
    // Remove keyword
    removeKeyword(y) {
      const { RULES: k } = this;
      delete k.keywords[y], delete k.all[y];
      for (const g of k.rules) {
        const o = g.rules.findIndex((l) => l.keyword === y);
        o >= 0 && g.rules.splice(o, 1);
      }
      return this;
    }
    // Add format
    addFormat(y, k) {
      return typeof k == "string" && (k = new RegExp(k)), this.formats[y] = k, this;
    }
    errorsText(y = this.errors, { separator: k = ", ", dataVar: g = "data" } = {}) {
      return !y || y.length === 0 ? "No errors" : y.map((o) => `${g}${o.instancePath} ${o.message}`).reduce((o, l) => o + k + l);
    }
    $dataMetaSchema(y, k) {
      const g = this.RULES.all;
      y = JSON.parse(JSON.stringify(y));
      for (const o of k) {
        const l = o.split("/").slice(1);
        let E = y;
        for (const q of l)
          E = E[q];
        for (const q in g) {
          const z = g[q];
          if (typeof z != "object")
            continue;
          const { $data: B } = z.definition, J = E[q];
          B && J && (E[q] = Pe(J));
        }
      }
      return y;
    }
    _removeAllSchemas(y, k) {
      for (const g in y) {
        const o = y[g];
        (!k || k.test(g)) && (typeof o == "string" ? delete y[g] : o && !o.meta && (this._cache.delete(o.schema), delete y[g]));
      }
    }
    _addSchema(y, k, g, o = this.opts.validateSchema, l = this.opts.addUsedSchema) {
      let E;
      const { schemaId: q } = this.opts;
      if (typeof y == "object")
        E = y[q];
      else {
        if (this.opts.jtd)
          throw new Error("schema must be object");
        if (typeof y != "boolean")
          throw new Error("schema must be object or boolean");
      }
      let z = this._cache.get(y);
      if (z !== void 0)
        return z;
      g = (0, d.normalizeId)(E || g);
      const B = d.getSchemaRefs.call(this, y, g);
      return z = new i.SchemaEnv({ schema: y, schemaId: q, meta: k, baseId: g, localRefs: B }), this._cache.set(z.schema, z), l && !g.startsWith("#") && (g && this._checkUnique(g), this.refs[g] = z), o && this.validateSchema(y, !0), z;
    }
    _checkUnique(y) {
      if (this.schemas[y] || this.refs[y])
        throw new Error(`schema with key or id "${y}" already exists`);
    }
    _compileSchemaEnv(y) {
      if (y.meta ? this._compileMetaSchema(y) : i.compileSchema.call(this, y), !y.validate)
        throw new Error("ajv implementation error");
      return y.validate;
    }
    _compileMetaSchema(y) {
      const k = this.opts;
      this.opts = this._metaOpts;
      try {
        i.compileSchema.call(this, y);
      } finally {
        this.opts = k;
      }
    }
  }
  M.ValidationError = n.default, M.MissingRefError = s.default, e.default = M;
  function F(C, y, k, g = "error") {
    for (const o in C) {
      const l = o;
      l in y && this.logger[g](`${k}: option ${o}. ${C[l]}`);
    }
  }
  function x(C) {
    return C = (0, d.normalizeId)(C), this.schemas[C] || this.refs[C];
  }
  function Y() {
    const C = this.opts.schemas;
    if (C)
      if (Array.isArray(C))
        this.addSchema(C);
      else
        for (const y in C)
          this.addSchema(C[y], y);
  }
  function se() {
    for (const C in this.opts.formats) {
      const y = this.opts.formats[C];
      y && this.addFormat(C, y);
    }
  }
  function m(C) {
    if (Array.isArray(C)) {
      this.addVocabulary(C);
      return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for (const y in C) {
      const k = C[y];
      k.keyword || (k.keyword = y), this.addKeyword(k);
    }
  }
  function S() {
    const C = { ...this.opts };
    for (const y of v)
      delete C[y];
    return C;
  }
  const j = { log() {
  }, warn() {
  }, error() {
  } };
  function P(C) {
    if (C === !1)
      return j;
    if (C === void 0)
      return console;
    if (C.log && C.warn && C.error)
      return C;
    throw new Error("logger must implement log, warn and error methods");
  }
  const T = /^[a-z_$][a-z0-9_$:-]*$/i;
  function R(C, y) {
    const { RULES: k } = this;
    if ((0, h.eachItem)(C, (g) => {
      if (k.keywords[g])
        throw new Error(`Keyword ${g} is already defined`);
      if (!T.test(g))
        throw new Error(`Keyword ${g} has invalid name`);
    }), !!y && y.$data && !("code" in y || "validate" in y))
      throw new Error('$data keyword must have "code" or "validate" function');
  }
  function D(C, y, k) {
    var g;
    const o = y?.post;
    if (k && o)
      throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: l } = this;
    let E = o ? l.post : l.rules.find(({ type: z }) => z === k);
    if (E || (E = { type: k, rules: [] }, l.rules.push(E)), l.keywords[C] = !0, !y)
      return;
    const q = {
      keyword: C,
      definition: {
        ...y,
        type: (0, c.getJSONTypes)(y.type),
        schemaType: (0, c.getJSONTypes)(y.schemaType)
      }
    };
    y.before ? O.call(this, E, q, y.before) : E.rules.push(q), l.all[C] = q, (g = y.implements) === null || g === void 0 || g.forEach((z) => this.addKeyword(z));
  }
  function O(C, y, k) {
    const g = C.rules.findIndex((o) => o.keyword === k);
    g >= 0 ? C.rules.splice(g, 0, y) : (C.rules.push(y), this.logger.warn(`rule ${k} is not defined`));
  }
  function G(C) {
    let { metaSchema: y } = C;
    y !== void 0 && (C.$data && this.opts.$data && (y = Pe(y)), C.validateSchema = this.compile(y, !0));
  }
  const Ie = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
  };
  function Pe(C) {
    return { anyOf: [C, Ie] };
  }
})(kn);
var gr = {}, _r = {}, vr = {};
Object.defineProperty(vr, "__esModule", { value: !0 });
const yi = {
  keyword: "id",
  code() {
    throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
  }
};
vr.default = yi;
var Te = {};
Object.defineProperty(Te, "__esModule", { value: !0 });
Te.callRef = Te.getValidate = void 0;
const $i = Ue, hn = L, oe = H, Me = $e, pn = ie, ot = A, gi = {
  keyword: "$ref",
  schemaType: "string",
  code(e) {
    const { gen: t, schema: r, it: n } = e, { baseId: s, schemaEnv: a, validateName: i, opts: u, self: d } = n, { root: c } = a;
    if ((r === "#" || r === "#/") && s === c.baseId)
      return p();
    const h = pn.resolveRef.call(d, c, s, r);
    if (h === void 0)
      throw new $i.default(n.opts.uriResolver, s, r);
    if (h instanceof pn.SchemaEnv)
      return N(h);
    return w(h);
    function p() {
      if (a === c)
        return ht(e, i, a, a.$async);
      const v = t.scopeValue("root", { ref: c });
      return ht(e, (0, oe._)`${v}.validate`, c, c.$async);
    }
    function N(v) {
      const b = ys(e, v);
      ht(e, b, v, v.$async);
    }
    function w(v) {
      const b = t.scopeValue("schema", u.code.source === !0 ? { ref: v, code: (0, oe.stringify)(v) } : { ref: v }), $ = t.name("valid"), f = e.subschema({
        schema: v,
        dataTypes: [],
        schemaPath: oe.nil,
        topSchemaRef: b,
        errSchemaPath: r
      }, $);
      e.mergeEvaluated(f), e.ok($);
    }
  }
};
function ys(e, t) {
  const { gen: r } = e;
  return t.validate ? r.scopeValue("validate", { ref: t.validate }) : (0, oe._)`${r.scopeValue("wrapper", { ref: t })}.validate`;
}
Te.getValidate = ys;
function ht(e, t, r, n) {
  const { gen: s, it: a } = e, { allErrors: i, schemaEnv: u, opts: d } = a, c = d.passContext ? Me.default.this : oe.nil;
  n ? h() : p();
  function h() {
    if (!u.$async)
      throw new Error("async schema referenced by sync schema");
    const v = s.let("valid");
    s.try(() => {
      s.code((0, oe._)`await ${(0, hn.callValidateCode)(e, t, c)}`), w(t), i || s.assign(v, !0);
    }, (b) => {
      s.if((0, oe._)`!(${b} instanceof ${a.ValidationError})`, () => s.throw(b)), N(b), i || s.assign(v, !1);
    }), e.ok(v);
  }
  function p() {
    e.result((0, hn.callValidateCode)(e, t, c), () => w(t), () => N(t));
  }
  function N(v) {
    const b = (0, oe._)`${v}.errors`;
    s.assign(Me.default.vErrors, (0, oe._)`${Me.default.vErrors} === null ? ${b} : ${Me.default.vErrors}.concat(${b})`), s.assign(Me.default.errors, (0, oe._)`${Me.default.vErrors}.length`);
  }
  function w(v) {
    var b;
    if (!a.opts.unevaluated)
      return;
    const $ = (b = r?.validate) === null || b === void 0 ? void 0 : b.evaluated;
    if (a.props !== !0)
      if ($ && !$.dynamicProps)
        $.props !== void 0 && (a.props = ot.mergeEvaluated.props(s, $.props, a.props));
      else {
        const f = s.var("props", (0, oe._)`${v}.evaluated.props`);
        a.props = ot.mergeEvaluated.props(s, f, a.props, oe.Name);
      }
    if (a.items !== !0)
      if ($ && !$.dynamicItems)
        $.items !== void 0 && (a.items = ot.mergeEvaluated.items(s, $.items, a.items));
      else {
        const f = s.var("items", (0, oe._)`${v}.evaluated.items`);
        a.items = ot.mergeEvaluated.items(s, f, a.items, oe.Name);
      }
  }
}
Te.callRef = ht;
Te.default = gi;
Object.defineProperty(_r, "__esModule", { value: !0 });
const _i = vr, vi = Te, wi = [
  "$schema",
  "$id",
  "$defs",
  "$vocabulary",
  { keyword: "$comment" },
  "definitions",
  _i.default,
  vi.default
];
_r.default = wi;
var wr = {}, br = {};
Object.defineProperty(br, "__esModule", { value: !0 });
const $t = H, be = $t.operators, gt = {
  maximum: { okStr: "<=", ok: be.LTE, fail: be.GT },
  minimum: { okStr: ">=", ok: be.GTE, fail: be.LT },
  exclusiveMaximum: { okStr: "<", ok: be.LT, fail: be.GTE },
  exclusiveMinimum: { okStr: ">", ok: be.GT, fail: be.LTE }
}, bi = {
  message: ({ keyword: e, schemaCode: t }) => (0, $t.str)`must be ${gt[e].okStr} ${t}`,
  params: ({ keyword: e, schemaCode: t }) => (0, $t._)`{comparison: ${gt[e].okStr}, limit: ${t}}`
}, Ei = {
  keyword: Object.keys(gt),
  type: "number",
  schemaType: "number",
  $data: !0,
  error: bi,
  code(e) {
    const { keyword: t, data: r, schemaCode: n } = e;
    e.fail$data((0, $t._)`${r} ${gt[t].fail} ${n} || isNaN(${r})`);
  }
};
br.default = Ei;
var Er = {};
Object.defineProperty(Er, "__esModule", { value: !0 });
const Xe = H, Si = {
  message: ({ schemaCode: e }) => (0, Xe.str)`must be multiple of ${e}`,
  params: ({ schemaCode: e }) => (0, Xe._)`{multipleOf: ${e}}`
}, Pi = {
  keyword: "multipleOf",
  type: "number",
  schemaType: "number",
  $data: !0,
  error: Si,
  code(e) {
    const { gen: t, data: r, schemaCode: n, it: s } = e, a = s.opts.multipleOfPrecision, i = t.let("res"), u = a ? (0, Xe._)`Math.abs(Math.round(${i}) - ${i}) > 1e-${a}` : (0, Xe._)`${i} !== parseInt(${i})`;
    e.fail$data((0, Xe._)`(${n} === 0 || (${i} = ${r}/${n}, ${u}))`);
  }
};
Er.default = Pi;
var Sr = {}, Pr = {};
Object.defineProperty(Pr, "__esModule", { value: !0 });
function $s(e) {
  const t = e.length;
  let r = 0, n = 0, s;
  for (; n < t; )
    r++, s = e.charCodeAt(n++), s >= 55296 && s <= 56319 && n < t && (s = e.charCodeAt(n), (s & 64512) === 56320 && n++);
  return r;
}
Pr.default = $s;
$s.code = 'require("ajv/dist/runtime/ucs2length").default';
Object.defineProperty(Sr, "__esModule", { value: !0 });
const ke = H, Ni = A, Ri = Pr, ki = {
  message({ keyword: e, schemaCode: t }) {
    const r = e === "maxLength" ? "more" : "fewer";
    return (0, ke.str)`must NOT have ${r} than ${t} characters`;
  },
  params: ({ schemaCode: e }) => (0, ke._)`{limit: ${e}}`
}, Oi = {
  keyword: ["maxLength", "minLength"],
  type: "string",
  schemaType: "number",
  $data: !0,
  error: ki,
  code(e) {
    const { keyword: t, data: r, schemaCode: n, it: s } = e, a = t === "maxLength" ? ke.operators.GT : ke.operators.LT, i = s.opts.unicode === !1 ? (0, ke._)`${r}.length` : (0, ke._)`${(0, Ni.useFunc)(e.gen, Ri.default)}(${r})`;
    e.fail$data((0, ke._)`${i} ${a} ${n}`);
  }
};
Sr.default = Oi;
var Nr = {};
Object.defineProperty(Nr, "__esModule", { value: !0 });
const ji = L, _t = H, Ti = {
  message: ({ schemaCode: e }) => (0, _t.str)`must match pattern "${e}"`,
  params: ({ schemaCode: e }) => (0, _t._)`{pattern: ${e}}`
}, Ii = {
  keyword: "pattern",
  type: "string",
  schemaType: "string",
  $data: !0,
  error: Ti,
  code(e) {
    const { data: t, $data: r, schema: n, schemaCode: s, it: a } = e, i = a.opts.unicodeRegExp ? "u" : "", u = r ? (0, _t._)`(new RegExp(${s}, ${i}))` : (0, ji.usePattern)(e, n);
    e.fail$data((0, _t._)`!${u}.test(${t})`);
  }
};
Nr.default = Ii;
var Rr = {};
Object.defineProperty(Rr, "__esModule", { value: !0 });
const Ye = H, Ci = {
  message({ keyword: e, schemaCode: t }) {
    const r = e === "maxProperties" ? "more" : "fewer";
    return (0, Ye.str)`must NOT have ${r} than ${t} properties`;
  },
  params: ({ schemaCode: e }) => (0, Ye._)`{limit: ${e}}`
}, Ai = {
  keyword: ["maxProperties", "minProperties"],
  type: "object",
  schemaType: "number",
  $data: !0,
  error: Ci,
  code(e) {
    const { keyword: t, data: r, schemaCode: n } = e, s = t === "maxProperties" ? Ye.operators.GT : Ye.operators.LT;
    e.fail$data((0, Ye._)`Object.keys(${r}).length ${s} ${n}`);
  }
};
Rr.default = Ai;
var kr = {};
Object.defineProperty(kr, "__esModule", { value: !0 });
const Ge = L, Qe = H, Mi = A, Fi = {
  message: ({ params: { missingProperty: e } }) => (0, Qe.str)`must have required property '${e}'`,
  params: ({ params: { missingProperty: e } }) => (0, Qe._)`{missingProperty: ${e}}`
}, Di = {
  keyword: "required",
  type: "object",
  schemaType: "array",
  $data: !0,
  error: Fi,
  code(e) {
    const { gen: t, schema: r, schemaCode: n, data: s, $data: a, it: i } = e, { opts: u } = i;
    if (!a && r.length === 0)
      return;
    const d = r.length >= u.loopRequired;
    if (i.allErrors ? c() : h(), u.strictRequired) {
      const w = e.parentSchema.properties, { definedProperties: v } = e.it;
      for (const b of r)
        if (w?.[b] === void 0 && !v.has(b)) {
          const $ = i.schemaEnv.baseId + i.errSchemaPath, f = `required property "${b}" is not defined at "${$}" (strictRequired)`;
          (0, Mi.checkStrictMode)(i, f, i.opts.strictRequired);
        }
    }
    function c() {
      if (d || a)
        e.block$data(Qe.nil, p);
      else
        for (const w of r)
          (0, Ge.checkReportMissingProp)(e, w);
    }
    function h() {
      const w = t.let("missing");
      if (d || a) {
        const v = t.let("valid", !0);
        e.block$data(v, () => N(w, v)), e.ok(v);
      } else
        t.if((0, Ge.checkMissingProp)(e, r, w)), (0, Ge.reportMissingProp)(e, w), t.else();
    }
    function p() {
      t.forOf("prop", n, (w) => {
        e.setParams({ missingProperty: w }), t.if((0, Ge.noPropertyInData)(t, s, w, u.ownProperties), () => e.error());
      });
    }
    function N(w, v) {
      e.setParams({ missingProperty: w }), t.forOf(w, n, () => {
        t.assign(v, (0, Ge.propertyInData)(t, s, w, u.ownProperties)), t.if((0, Qe.not)(v), () => {
          e.error(), t.break();
        });
      }, Qe.nil);
    }
  }
};
kr.default = Di;
var Or = {};
Object.defineProperty(Or, "__esModule", { value: !0 });
const Ze = H, Vi = {
  message({ keyword: e, schemaCode: t }) {
    const r = e === "maxItems" ? "more" : "fewer";
    return (0, Ze.str)`must NOT have ${r} than ${t} items`;
  },
  params: ({ schemaCode: e }) => (0, Ze._)`{limit: ${e}}`
}, qi = {
  keyword: ["maxItems", "minItems"],
  type: "array",
  schemaType: "number",
  $data: !0,
  error: Vi,
  code(e) {
    const { keyword: t, data: r, schemaCode: n } = e, s = t === "maxItems" ? Ze.operators.GT : Ze.operators.LT;
    e.fail$data((0, Ze._)`${r}.length ${s} ${n}`);
  }
};
Or.default = qi;
var jr = {}, nt = {};
Object.defineProperty(nt, "__esModule", { value: !0 });
const gs = Ln;
gs.code = 'require("ajv/dist/runtime/equal").default';
nt.default = gs;
Object.defineProperty(jr, "__esModule", { value: !0 });
const Gt = Z, te = H, zi = A, Ui = nt, xi = {
  message: ({ params: { i: e, j: t } }) => (0, te.str)`must NOT have duplicate items (items ## ${t} and ${e} are identical)`,
  params: ({ params: { i: e, j: t } }) => (0, te._)`{i: ${e}, j: ${t}}`
}, Ki = {
  keyword: "uniqueItems",
  type: "array",
  schemaType: "boolean",
  $data: !0,
  error: xi,
  code(e) {
    const { gen: t, data: r, $data: n, schema: s, parentSchema: a, schemaCode: i, it: u } = e;
    if (!n && !s)
      return;
    const d = t.let("valid"), c = a.items ? (0, Gt.getSchemaTypes)(a.items) : [];
    e.block$data(d, h, (0, te._)`${i} === false`), e.ok(d);
    function h() {
      const v = t.let("i", (0, te._)`${r}.length`), b = t.let("j");
      e.setParams({ i: v, j: b }), t.assign(d, !0), t.if((0, te._)`${v} > 1`, () => (p() ? N : w)(v, b));
    }
    function p() {
      return c.length > 0 && !c.some((v) => v === "object" || v === "array");
    }
    function N(v, b) {
      const $ = t.name("item"), f = (0, Gt.checkDataTypes)(c, $, u.opts.strictNumbers, Gt.DataType.Wrong), _ = t.const("indices", (0, te._)`{}`);
      t.for((0, te._)`;${v}--;`, () => {
        t.let($, (0, te._)`${r}[${v}]`), t.if(f, (0, te._)`continue`), c.length > 1 && t.if((0, te._)`typeof ${$} == "string"`, (0, te._)`${$} += "_"`), t.if((0, te._)`typeof ${_}[${$}] == "number"`, () => {
          t.assign(b, (0, te._)`${_}[${$}]`), e.error(), t.assign(d, !1).break();
        }).code((0, te._)`${_}[${$}] = ${v}`);
      });
    }
    function w(v, b) {
      const $ = (0, zi.useFunc)(t, Ui.default), f = t.name("outer");
      t.label(f).for((0, te._)`;${v}--;`, () => t.for((0, te._)`${b} = ${v}; ${b}--;`, () => t.if((0, te._)`${$}(${r}[${v}], ${r}[${b}])`, () => {
        e.error(), t.assign(d, !1).break(f);
      })));
    }
  }
};
jr.default = Ki;
var Tr = {};
Object.defineProperty(Tr, "__esModule", { value: !0 });
const er = H, Li = A, Hi = nt, Gi = {
  message: "must be equal to constant",
  params: ({ schemaCode: e }) => (0, er._)`{allowedValue: ${e}}`
}, Ji = {
  keyword: "const",
  $data: !0,
  error: Gi,
  code(e) {
    const { gen: t, data: r, $data: n, schemaCode: s, schema: a } = e;
    n || a && typeof a == "object" ? e.fail$data((0, er._)`!${(0, Li.useFunc)(t, Hi.default)}(${r}, ${s})`) : e.fail((0, er._)`${a} !== ${r}`);
  }
};
Tr.default = Ji;
var Ir = {};
Object.defineProperty(Ir, "__esModule", { value: !0 });
const Be = H, Bi = A, Wi = nt, Xi = {
  message: "must be equal to one of the allowed values",
  params: ({ schemaCode: e }) => (0, Be._)`{allowedValues: ${e}}`
}, Yi = {
  keyword: "enum",
  schemaType: "array",
  $data: !0,
  error: Xi,
  code(e) {
    const { gen: t, data: r, $data: n, schema: s, schemaCode: a, it: i } = e;
    if (!n && s.length === 0)
      throw new Error("enum must have non-empty array");
    const u = s.length >= i.opts.loopEnum;
    let d;
    const c = () => d ?? (d = (0, Bi.useFunc)(t, Wi.default));
    let h;
    if (u || n)
      h = t.let("valid"), e.block$data(h, p);
    else {
      if (!Array.isArray(s))
        throw new Error("ajv implementation error");
      const w = t.const("vSchema", a);
      h = (0, Be.or)(...s.map((v, b) => N(w, b)));
    }
    e.pass(h);
    function p() {
      t.assign(h, !1), t.forOf("v", a, (w) => t.if((0, Be._)`${c()}(${r}, ${w})`, () => t.assign(h, !0).break()));
    }
    function N(w, v) {
      const b = s[v];
      return typeof b == "object" && b !== null ? (0, Be._)`${c()}(${r}, ${w}[${v}])` : (0, Be._)`${r} === ${b}`;
    }
  }
};
Ir.default = Yi;
Object.defineProperty(wr, "__esModule", { value: !0 });
const Qi = br, Zi = Er, ec = Sr, tc = Nr, rc = Rr, nc = kr, sc = Or, ac = jr, oc = Tr, ic = Ir, cc = [
  // number
  Qi.default,
  Zi.default,
  // string
  ec.default,
  tc.default,
  // object
  rc.default,
  nc.default,
  // array
  sc.default,
  ac.default,
  // any
  { keyword: "type", schemaType: ["string", "array"] },
  { keyword: "nullable", schemaType: "boolean" },
  oc.default,
  ic.default
];
wr.default = cc;
var Cr = {}, xe = {};
Object.defineProperty(xe, "__esModule", { value: !0 });
xe.validateAdditionalItems = void 0;
const Oe = H, tr = A, uc = {
  message: ({ params: { len: e } }) => (0, Oe.str)`must NOT have more than ${e} items`,
  params: ({ params: { len: e } }) => (0, Oe._)`{limit: ${e}}`
}, lc = {
  keyword: "additionalItems",
  type: "array",
  schemaType: ["boolean", "object"],
  before: "uniqueItems",
  error: uc,
  code(e) {
    const { parentSchema: t, it: r } = e, { items: n } = t;
    if (!Array.isArray(n)) {
      (0, tr.checkStrictMode)(r, '"additionalItems" is ignored when "items" is not an array of schemas');
      return;
    }
    _s(e, n);
  }
};
function _s(e, t) {
  const { gen: r, schema: n, data: s, keyword: a, it: i } = e;
  i.items = !0;
  const u = r.const("len", (0, Oe._)`${s}.length`);
  if (n === !1)
    e.setParams({ len: t.length }), e.pass((0, Oe._)`${u} <= ${t.length}`);
  else if (typeof n == "object" && !(0, tr.alwaysValidSchema)(i, n)) {
    const c = r.var("valid", (0, Oe._)`${u} <= ${t.length}`);
    r.if((0, Oe.not)(c), () => d(c)), e.ok(c);
  }
  function d(c) {
    r.forRange("i", t.length, u, (h) => {
      e.subschema({ keyword: a, dataProp: h, dataPropType: tr.Type.Num }, c), i.allErrors || r.if((0, Oe.not)(c), () => r.break());
    });
  }
}
xe.validateAdditionalItems = _s;
xe.default = lc;
var Ar = {}, Ke = {};
Object.defineProperty(Ke, "__esModule", { value: !0 });
Ke.validateTuple = void 0;
const mn = H, pt = A, dc = L, fc = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "array", "boolean"],
  before: "uniqueItems",
  code(e) {
    const { schema: t, it: r } = e;
    if (Array.isArray(t))
      return vs(e, "additionalItems", t);
    r.items = !0, !(0, pt.alwaysValidSchema)(r, t) && e.ok((0, dc.validateArray)(e));
  }
};
function vs(e, t, r = e.schema) {
  const { gen: n, parentSchema: s, data: a, keyword: i, it: u } = e;
  h(s), u.opts.unevaluated && r.length && u.items !== !0 && (u.items = pt.mergeEvaluated.items(n, r.length, u.items));
  const d = n.name("valid"), c = n.const("len", (0, mn._)`${a}.length`);
  r.forEach((p, N) => {
    (0, pt.alwaysValidSchema)(u, p) || (n.if((0, mn._)`${c} > ${N}`, () => e.subschema({
      keyword: i,
      schemaProp: N,
      dataProp: N
    }, d)), e.ok(d));
  });
  function h(p) {
    const { opts: N, errSchemaPath: w } = u, v = r.length, b = v === p.minItems && (v === p.maxItems || p[t] === !1);
    if (N.strictTuples && !b) {
      const $ = `"${i}" is ${v}-tuple, but minItems or maxItems/${t} are not specified or different at path "${w}"`;
      (0, pt.checkStrictMode)(u, $, N.strictTuples);
    }
  }
}
Ke.validateTuple = vs;
Ke.default = fc;
Object.defineProperty(Ar, "__esModule", { value: !0 });
const hc = Ke, pc = {
  keyword: "prefixItems",
  type: "array",
  schemaType: ["array"],
  before: "uniqueItems",
  code: (e) => (0, hc.validateTuple)(e, "items")
};
Ar.default = pc;
var Mr = {};
Object.defineProperty(Mr, "__esModule", { value: !0 });
const yn = H, mc = A, yc = L, $c = xe, gc = {
  message: ({ params: { len: e } }) => (0, yn.str)`must NOT have more than ${e} items`,
  params: ({ params: { len: e } }) => (0, yn._)`{limit: ${e}}`
}, _c = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  error: gc,
  code(e) {
    const { schema: t, parentSchema: r, it: n } = e, { prefixItems: s } = r;
    n.items = !0, !(0, mc.alwaysValidSchema)(n, t) && (s ? (0, $c.validateAdditionalItems)(e, s) : e.ok((0, yc.validateArray)(e)));
  }
};
Mr.default = _c;
var Fr = {};
Object.defineProperty(Fr, "__esModule", { value: !0 });
const ce = H, it = A, vc = {
  message: ({ params: { min: e, max: t } }) => t === void 0 ? (0, ce.str)`must contain at least ${e} valid item(s)` : (0, ce.str)`must contain at least ${e} and no more than ${t} valid item(s)`,
  params: ({ params: { min: e, max: t } }) => t === void 0 ? (0, ce._)`{minContains: ${e}}` : (0, ce._)`{minContains: ${e}, maxContains: ${t}}`
}, wc = {
  keyword: "contains",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  trackErrors: !0,
  error: vc,
  code(e) {
    const { gen: t, schema: r, parentSchema: n, data: s, it: a } = e;
    let i, u;
    const { minContains: d, maxContains: c } = n;
    a.opts.next ? (i = d === void 0 ? 1 : d, u = c) : i = 1;
    const h = t.const("len", (0, ce._)`${s}.length`);
    if (e.setParams({ min: i, max: u }), u === void 0 && i === 0) {
      (0, it.checkStrictMode)(a, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
      return;
    }
    if (u !== void 0 && i > u) {
      (0, it.checkStrictMode)(a, '"minContains" > "maxContains" is always invalid'), e.fail();
      return;
    }
    if ((0, it.alwaysValidSchema)(a, r)) {
      let b = (0, ce._)`${h} >= ${i}`;
      u !== void 0 && (b = (0, ce._)`${b} && ${h} <= ${u}`), e.pass(b);
      return;
    }
    a.items = !0;
    const p = t.name("valid");
    u === void 0 && i === 1 ? w(p, () => t.if(p, () => t.break())) : i === 0 ? (t.let(p, !0), u !== void 0 && t.if((0, ce._)`${s}.length > 0`, N)) : (t.let(p, !1), N()), e.result(p, () => e.reset());
    function N() {
      const b = t.name("_valid"), $ = t.let("count", 0);
      w(b, () => t.if(b, () => v($)));
    }
    function w(b, $) {
      t.forRange("i", 0, h, (f) => {
        e.subschema({
          keyword: "contains",
          dataProp: f,
          dataPropType: it.Type.Num,
          compositeRule: !0
        }, b), $();
      });
    }
    function v(b) {
      t.code((0, ce._)`${b}++`), u === void 0 ? t.if((0, ce._)`${b} >= ${i}`, () => t.assign(p, !0).break()) : (t.if((0, ce._)`${b} > ${u}`, () => t.assign(p, !1).break()), i === 1 ? t.assign(p, !0) : t.if((0, ce._)`${b} >= ${i}`, () => t.assign(p, !0)));
    }
  }
};
Fr.default = wc;
var ws = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.validateSchemaDeps = e.validatePropertyDeps = e.error = void 0;
  const t = H, r = A, n = L;
  e.error = {
    message: ({ params: { property: d, depsCount: c, deps: h } }) => {
      const p = c === 1 ? "property" : "properties";
      return (0, t.str)`must have ${p} ${h} when property ${d} is present`;
    },
    params: ({ params: { property: d, depsCount: c, deps: h, missingProperty: p } }) => (0, t._)`{property: ${d},
    missingProperty: ${p},
    depsCount: ${c},
    deps: ${h}}`
    // TODO change to reference
  };
  const s = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: e.error,
    code(d) {
      const [c, h] = a(d);
      i(d, c), u(d, h);
    }
  };
  function a({ schema: d }) {
    const c = {}, h = {};
    for (const p in d) {
      if (p === "__proto__")
        continue;
      const N = Array.isArray(d[p]) ? c : h;
      N[p] = d[p];
    }
    return [c, h];
  }
  function i(d, c = d.schema) {
    const { gen: h, data: p, it: N } = d;
    if (Object.keys(c).length === 0)
      return;
    const w = h.let("missing");
    for (const v in c) {
      const b = c[v];
      if (b.length === 0)
        continue;
      const $ = (0, n.propertyInData)(h, p, v, N.opts.ownProperties);
      d.setParams({
        property: v,
        depsCount: b.length,
        deps: b.join(", ")
      }), N.allErrors ? h.if($, () => {
        for (const f of b)
          (0, n.checkReportMissingProp)(d, f);
      }) : (h.if((0, t._)`${$} && (${(0, n.checkMissingProp)(d, b, w)})`), (0, n.reportMissingProp)(d, w), h.else());
    }
  }
  e.validatePropertyDeps = i;
  function u(d, c = d.schema) {
    const { gen: h, data: p, keyword: N, it: w } = d, v = h.name("valid");
    for (const b in c)
      (0, r.alwaysValidSchema)(w, c[b]) || (h.if(
        (0, n.propertyInData)(h, p, b, w.opts.ownProperties),
        () => {
          const $ = d.subschema({ keyword: N, schemaProp: b }, v);
          d.mergeValidEvaluated($, v);
        },
        () => h.var(v, !0)
        // TODO var
      ), d.ok(v));
  }
  e.validateSchemaDeps = u, e.default = s;
})(ws);
var Dr = {};
Object.defineProperty(Dr, "__esModule", { value: !0 });
const bs = H, bc = A, Ec = {
  message: "property name must be valid",
  params: ({ params: e }) => (0, bs._)`{propertyName: ${e.propertyName}}`
}, Sc = {
  keyword: "propertyNames",
  type: "object",
  schemaType: ["object", "boolean"],
  error: Ec,
  code(e) {
    const { gen: t, schema: r, data: n, it: s } = e;
    if ((0, bc.alwaysValidSchema)(s, r))
      return;
    const a = t.name("valid");
    t.forIn("key", n, (i) => {
      e.setParams({ propertyName: i }), e.subschema({
        keyword: "propertyNames",
        data: i,
        dataTypes: ["string"],
        propertyName: i,
        compositeRule: !0
      }, a), t.if((0, bs.not)(a), () => {
        e.error(!0), s.allErrors || t.break();
      });
    }), e.ok(a);
  }
};
Dr.default = Sc;
var Pt = {};
Object.defineProperty(Pt, "__esModule", { value: !0 });
const ct = L, le = H, Pc = $e, ut = A, Nc = {
  message: "must NOT have additional properties",
  params: ({ params: e }) => (0, le._)`{additionalProperty: ${e.additionalProperty}}`
}, Rc = {
  keyword: "additionalProperties",
  type: ["object"],
  schemaType: ["boolean", "object"],
  allowUndefined: !0,
  trackErrors: !0,
  error: Nc,
  code(e) {
    const { gen: t, schema: r, parentSchema: n, data: s, errsCount: a, it: i } = e;
    if (!a)
      throw new Error("ajv implementation error");
    const { allErrors: u, opts: d } = i;
    if (i.props = !0, d.removeAdditional !== "all" && (0, ut.alwaysValidSchema)(i, r))
      return;
    const c = (0, ct.allSchemaProperties)(n.properties), h = (0, ct.allSchemaProperties)(n.patternProperties);
    p(), e.ok((0, le._)`${a} === ${Pc.default.errors}`);
    function p() {
      t.forIn("key", s, ($) => {
        !c.length && !h.length ? v($) : t.if(N($), () => v($));
      });
    }
    function N($) {
      let f;
      if (c.length > 8) {
        const _ = (0, ut.schemaRefOrVal)(i, n.properties, "properties");
        f = (0, ct.isOwnProperty)(t, _, $);
      } else c.length ? f = (0, le.or)(...c.map((_) => (0, le._)`${$} === ${_}`)) : f = le.nil;
      return h.length && (f = (0, le.or)(f, ...h.map((_) => (0, le._)`${(0, ct.usePattern)(e, _)}.test(${$})`))), (0, le.not)(f);
    }
    function w($) {
      t.code((0, le._)`delete ${s}[${$}]`);
    }
    function v($) {
      if (d.removeAdditional === "all" || d.removeAdditional && r === !1) {
        w($);
        return;
      }
      if (r === !1) {
        e.setParams({ additionalProperty: $ }), e.error(), u || t.break();
        return;
      }
      if (typeof r == "object" && !(0, ut.alwaysValidSchema)(i, r)) {
        const f = t.name("valid");
        d.removeAdditional === "failing" ? (b($, f, !1), t.if((0, le.not)(f), () => {
          e.reset(), w($);
        })) : (b($, f), u || t.if((0, le.not)(f), () => t.break()));
      }
    }
    function b($, f, _) {
      const I = {
        keyword: "additionalProperties",
        dataProp: $,
        dataPropType: ut.Type.Str
      };
      _ === !1 && Object.assign(I, {
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }), e.subschema(I, f);
    }
  }
};
Pt.default = Rc;
var Vr = {};
Object.defineProperty(Vr, "__esModule", { value: !0 });
const kc = fe, $n = L, Jt = A, gn = Pt, Oc = {
  keyword: "properties",
  type: "object",
  schemaType: "object",
  code(e) {
    const { gen: t, schema: r, parentSchema: n, data: s, it: a } = e;
    a.opts.removeAdditional === "all" && n.additionalProperties === void 0 && gn.default.code(new kc.KeywordCxt(a, gn.default, "additionalProperties"));
    const i = (0, $n.allSchemaProperties)(r);
    for (const p of i)
      a.definedProperties.add(p);
    a.opts.unevaluated && i.length && a.props !== !0 && (a.props = Jt.mergeEvaluated.props(t, (0, Jt.toHash)(i), a.props));
    const u = i.filter((p) => !(0, Jt.alwaysValidSchema)(a, r[p]));
    if (u.length === 0)
      return;
    const d = t.name("valid");
    for (const p of u)
      c(p) ? h(p) : (t.if((0, $n.propertyInData)(t, s, p, a.opts.ownProperties)), h(p), a.allErrors || t.else().var(d, !0), t.endIf()), e.it.definedProperties.add(p), e.ok(d);
    function c(p) {
      return a.opts.useDefaults && !a.compositeRule && r[p].default !== void 0;
    }
    function h(p) {
      e.subschema({
        keyword: "properties",
        schemaProp: p,
        dataProp: p
      }, d);
    }
  }
};
Vr.default = Oc;
var qr = {};
Object.defineProperty(qr, "__esModule", { value: !0 });
const _n = L, lt = H, vn = A, wn = A, jc = {
  keyword: "patternProperties",
  type: "object",
  schemaType: "object",
  code(e) {
    const { gen: t, schema: r, data: n, parentSchema: s, it: a } = e, { opts: i } = a, u = (0, _n.allSchemaProperties)(r), d = u.filter((b) => (0, vn.alwaysValidSchema)(a, r[b]));
    if (u.length === 0 || d.length === u.length && (!a.opts.unevaluated || a.props === !0))
      return;
    const c = i.strictSchema && !i.allowMatchingProperties && s.properties, h = t.name("valid");
    a.props !== !0 && !(a.props instanceof lt.Name) && (a.props = (0, wn.evaluatedPropsToName)(t, a.props));
    const { props: p } = a;
    N();
    function N() {
      for (const b of u)
        c && w(b), a.allErrors ? v(b) : (t.var(h, !0), v(b), t.if(h));
    }
    function w(b) {
      for (const $ in c)
        new RegExp(b).test($) && (0, vn.checkStrictMode)(a, `property ${$} matches pattern ${b} (use allowMatchingProperties)`);
    }
    function v(b) {
      t.forIn("key", n, ($) => {
        t.if((0, lt._)`${(0, _n.usePattern)(e, b)}.test(${$})`, () => {
          const f = d.includes(b);
          f || e.subschema({
            keyword: "patternProperties",
            schemaProp: b,
            dataProp: $,
            dataPropType: wn.Type.Str
          }, h), a.opts.unevaluated && p !== !0 ? t.assign((0, lt._)`${p}[${$}]`, !0) : !f && !a.allErrors && t.if((0, lt.not)(h), () => t.break());
        });
      });
    }
  }
};
qr.default = jc;
var zr = {};
Object.defineProperty(zr, "__esModule", { value: !0 });
const Tc = A, Ic = {
  keyword: "not",
  schemaType: ["object", "boolean"],
  trackErrors: !0,
  code(e) {
    const { gen: t, schema: r, it: n } = e;
    if ((0, Tc.alwaysValidSchema)(n, r)) {
      e.fail();
      return;
    }
    const s = t.name("valid");
    e.subschema({
      keyword: "not",
      compositeRule: !0,
      createErrors: !1,
      allErrors: !1
    }, s), e.failResult(s, () => e.reset(), () => e.error());
  },
  error: { message: "must NOT be valid" }
};
zr.default = Ic;
var Ur = {};
Object.defineProperty(Ur, "__esModule", { value: !0 });
const Cc = L, Ac = {
  keyword: "anyOf",
  schemaType: "array",
  trackErrors: !0,
  code: Cc.validateUnion,
  error: { message: "must match a schema in anyOf" }
};
Ur.default = Ac;
var xr = {};
Object.defineProperty(xr, "__esModule", { value: !0 });
const mt = H, Mc = A, Fc = {
  message: "must match exactly one schema in oneOf",
  params: ({ params: e }) => (0, mt._)`{passingSchemas: ${e.passing}}`
}, Dc = {
  keyword: "oneOf",
  schemaType: "array",
  trackErrors: !0,
  error: Fc,
  code(e) {
    const { gen: t, schema: r, parentSchema: n, it: s } = e;
    if (!Array.isArray(r))
      throw new Error("ajv implementation error");
    if (s.opts.discriminator && n.discriminator)
      return;
    const a = r, i = t.let("valid", !1), u = t.let("passing", null), d = t.name("_valid");
    e.setParams({ passing: u }), t.block(c), e.result(i, () => e.reset(), () => e.error(!0));
    function c() {
      a.forEach((h, p) => {
        let N;
        (0, Mc.alwaysValidSchema)(s, h) ? t.var(d, !0) : N = e.subschema({
          keyword: "oneOf",
          schemaProp: p,
          compositeRule: !0
        }, d), p > 0 && t.if((0, mt._)`${d} && ${i}`).assign(i, !1).assign(u, (0, mt._)`[${u}, ${p}]`).else(), t.if(d, () => {
          t.assign(i, !0), t.assign(u, p), N && e.mergeEvaluated(N, mt.Name);
        });
      });
    }
  }
};
xr.default = Dc;
var Kr = {};
Object.defineProperty(Kr, "__esModule", { value: !0 });
const Vc = A, qc = {
  keyword: "allOf",
  schemaType: "array",
  code(e) {
    const { gen: t, schema: r, it: n } = e;
    if (!Array.isArray(r))
      throw new Error("ajv implementation error");
    const s = t.name("valid");
    r.forEach((a, i) => {
      if ((0, Vc.alwaysValidSchema)(n, a))
        return;
      const u = e.subschema({ keyword: "allOf", schemaProp: i }, s);
      e.ok(s), e.mergeEvaluated(u);
    });
  }
};
Kr.default = qc;
var Lr = {};
Object.defineProperty(Lr, "__esModule", { value: !0 });
const vt = H, Es = A, zc = {
  message: ({ params: e }) => (0, vt.str)`must match "${e.ifClause}" schema`,
  params: ({ params: e }) => (0, vt._)`{failingKeyword: ${e.ifClause}}`
}, Uc = {
  keyword: "if",
  schemaType: ["object", "boolean"],
  trackErrors: !0,
  error: zc,
  code(e) {
    const { gen: t, parentSchema: r, it: n } = e;
    r.then === void 0 && r.else === void 0 && (0, Es.checkStrictMode)(n, '"if" without "then" and "else" is ignored');
    const s = bn(n, "then"), a = bn(n, "else");
    if (!s && !a)
      return;
    const i = t.let("valid", !0), u = t.name("_valid");
    if (d(), e.reset(), s && a) {
      const h = t.let("ifClause");
      e.setParams({ ifClause: h }), t.if(u, c("then", h), c("else", h));
    } else s ? t.if(u, c("then")) : t.if((0, vt.not)(u), c("else"));
    e.pass(i, () => e.error(!0));
    function d() {
      const h = e.subschema({
        keyword: "if",
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }, u);
      e.mergeEvaluated(h);
    }
    function c(h, p) {
      return () => {
        const N = e.subschema({ keyword: h }, u);
        t.assign(i, u), e.mergeValidEvaluated(N, i), p ? t.assign(p, (0, vt._)`${h}`) : e.setParams({ ifClause: h });
      };
    }
  }
};
function bn(e, t) {
  const r = e.schema[t];
  return r !== void 0 && !(0, Es.alwaysValidSchema)(e, r);
}
Lr.default = Uc;
var Hr = {};
Object.defineProperty(Hr, "__esModule", { value: !0 });
const xc = A, Kc = {
  keyword: ["then", "else"],
  schemaType: ["object", "boolean"],
  code({ keyword: e, parentSchema: t, it: r }) {
    t.if === void 0 && (0, xc.checkStrictMode)(r, `"${e}" without "if" is ignored`);
  }
};
Hr.default = Kc;
Object.defineProperty(Cr, "__esModule", { value: !0 });
const Lc = xe, Hc = Ar, Gc = Ke, Jc = Mr, Bc = Fr, Wc = ws, Xc = Dr, Yc = Pt, Qc = Vr, Zc = qr, eu = zr, tu = Ur, ru = xr, nu = Kr, su = Lr, au = Hr;
function ou(e = !1) {
  const t = [
    // any
    eu.default,
    tu.default,
    ru.default,
    nu.default,
    su.default,
    au.default,
    // object
    Xc.default,
    Yc.default,
    Wc.default,
    Qc.default,
    Zc.default
  ];
  return e ? t.push(Hc.default, Jc.default) : t.push(Lc.default, Gc.default), t.push(Bc.default), t;
}
Cr.default = ou;
var Gr = {}, Jr = {};
Object.defineProperty(Jr, "__esModule", { value: !0 });
const Q = H, iu = {
  message: ({ schemaCode: e }) => (0, Q.str)`must match format "${e}"`,
  params: ({ schemaCode: e }) => (0, Q._)`{format: ${e}}`
}, cu = {
  keyword: "format",
  type: ["number", "string"],
  schemaType: "string",
  $data: !0,
  error: iu,
  code(e, t) {
    const { gen: r, data: n, $data: s, schema: a, schemaCode: i, it: u } = e, { opts: d, errSchemaPath: c, schemaEnv: h, self: p } = u;
    if (!d.validateFormats)
      return;
    s ? N() : w();
    function N() {
      const v = r.scopeValue("formats", {
        ref: p.formats,
        code: d.code.formats
      }), b = r.const("fDef", (0, Q._)`${v}[${i}]`), $ = r.let("fType"), f = r.let("format");
      r.if((0, Q._)`typeof ${b} == "object" && !(${b} instanceof RegExp)`, () => r.assign($, (0, Q._)`${b}.type || "string"`).assign(f, (0, Q._)`${b}.validate`), () => r.assign($, (0, Q._)`"string"`).assign(f, b)), e.fail$data((0, Q.or)(_(), I()));
      function _() {
        return d.strictSchema === !1 ? Q.nil : (0, Q._)`${i} && !${f}`;
      }
      function I() {
        const M = h.$async ? (0, Q._)`(${b}.async ? await ${f}(${n}) : ${f}(${n}))` : (0, Q._)`${f}(${n})`, F = (0, Q._)`(typeof ${f} == "function" ? ${M} : ${f}.test(${n}))`;
        return (0, Q._)`${f} && ${f} !== true && ${$} === ${t} && !${F}`;
      }
    }
    function w() {
      const v = p.formats[a];
      if (!v) {
        _();
        return;
      }
      if (v === !0)
        return;
      const [b, $, f] = I(v);
      b === t && e.pass(M());
      function _() {
        if (d.strictSchema === !1) {
          p.logger.warn(F());
          return;
        }
        throw new Error(F());
        function F() {
          return `unknown format "${a}" ignored in schema at path "${c}"`;
        }
      }
      function I(F) {
        const x = F instanceof RegExp ? (0, Q.regexpCode)(F) : d.code.formats ? (0, Q._)`${d.code.formats}${(0, Q.getProperty)(a)}` : void 0, Y = r.scopeValue("formats", { key: a, ref: F, code: x });
        return typeof F == "object" && !(F instanceof RegExp) ? [F.type || "string", F.validate, (0, Q._)`${Y}.validate`] : ["string", F, Y];
      }
      function M() {
        if (typeof v == "object" && !(v instanceof RegExp) && v.async) {
          if (!h.$async)
            throw new Error("async format in sync schema");
          return (0, Q._)`await ${f}(${n})`;
        }
        return typeof $ == "function" ? (0, Q._)`${f}(${n})` : (0, Q._)`${f}.test(${n})`;
      }
    }
  }
};
Jr.default = cu;
Object.defineProperty(Gr, "__esModule", { value: !0 });
const uu = Jr, lu = [uu.default];
Gr.default = lu;
var ze = {};
Object.defineProperty(ze, "__esModule", { value: !0 });
ze.contentVocabulary = ze.metadataVocabulary = void 0;
ze.metadataVocabulary = [
  "title",
  "description",
  "default",
  "deprecated",
  "readOnly",
  "writeOnly",
  "examples"
];
ze.contentVocabulary = [
  "contentMediaType",
  "contentEncoding",
  "contentSchema"
];
Object.defineProperty(gr, "__esModule", { value: !0 });
const du = _r, fu = wr, hu = Cr, pu = Gr, En = ze, mu = [
  du.default,
  fu.default,
  (0, hu.default)(),
  pu.default,
  En.metadataVocabulary,
  En.contentVocabulary
];
gr.default = mu;
var Br = {}, Nt = {};
Object.defineProperty(Nt, "__esModule", { value: !0 });
Nt.DiscrError = void 0;
var Sn;
(function(e) {
  e.Tag = "tag", e.Mapping = "mapping";
})(Sn || (Nt.DiscrError = Sn = {}));
Object.defineProperty(Br, "__esModule", { value: !0 });
const Fe = H, rr = Nt, Pn = ie, yu = Ue, $u = A, gu = {
  message: ({ params: { discrError: e, tagName: t } }) => e === rr.DiscrError.Tag ? `tag "${t}" must be string` : `value of tag "${t}" must be in oneOf`,
  params: ({ params: { discrError: e, tag: t, tagName: r } }) => (0, Fe._)`{error: ${e}, tag: ${r}, tagValue: ${t}}`
}, _u = {
  keyword: "discriminator",
  type: "object",
  schemaType: "object",
  error: gu,
  code(e) {
    const { gen: t, data: r, schema: n, parentSchema: s, it: a } = e, { oneOf: i } = s;
    if (!a.opts.discriminator)
      throw new Error("discriminator: requires discriminator option");
    const u = n.propertyName;
    if (typeof u != "string")
      throw new Error("discriminator: requires propertyName");
    if (n.mapping)
      throw new Error("discriminator: mapping is not supported");
    if (!i)
      throw new Error("discriminator: requires oneOf keyword");
    const d = t.let("valid", !1), c = t.const("tag", (0, Fe._)`${r}${(0, Fe.getProperty)(u)}`);
    t.if((0, Fe._)`typeof ${c} == "string"`, () => h(), () => e.error(!1, { discrError: rr.DiscrError.Tag, tag: c, tagName: u })), e.ok(d);
    function h() {
      const w = N();
      t.if(!1);
      for (const v in w)
        t.elseIf((0, Fe._)`${c} === ${v}`), t.assign(d, p(w[v]));
      t.else(), e.error(!1, { discrError: rr.DiscrError.Mapping, tag: c, tagName: u }), t.endIf();
    }
    function p(w) {
      const v = t.name("valid"), b = e.subschema({ keyword: "oneOf", schemaProp: w }, v);
      return e.mergeEvaluated(b, Fe.Name), v;
    }
    function N() {
      var w;
      const v = {}, b = f(s);
      let $ = !0;
      for (let M = 0; M < i.length; M++) {
        let F = i[M];
        if (F?.$ref && !(0, $u.schemaHasRulesButRef)(F, a.self.RULES)) {
          const Y = F.$ref;
          if (F = Pn.resolveRef.call(a.self, a.schemaEnv.root, a.baseId, Y), F instanceof Pn.SchemaEnv && (F = F.schema), F === void 0)
            throw new yu.default(a.opts.uriResolver, a.baseId, Y);
        }
        const x = (w = F?.properties) === null || w === void 0 ? void 0 : w[u];
        if (typeof x != "object")
          throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${u}"`);
        $ = $ && (b || f(F)), _(x, M);
      }
      if (!$)
        throw new Error(`discriminator: "${u}" must be required`);
      return v;
      function f({ required: M }) {
        return Array.isArray(M) && M.includes(u);
      }
      function _(M, F) {
        if (M.const)
          I(M.const, F);
        else if (M.enum)
          for (const x of M.enum)
            I(x, F);
        else
          throw new Error(`discriminator: "properties/${u}" must have "const" or "enum"`);
      }
      function I(M, F) {
        if (typeof M != "string" || M in v)
          throw new Error(`discriminator: "${u}" values must be unique strings`);
        v[M] = F;
      }
    }
  }
};
Br.default = _u;
const vu = "http://json-schema.org/draft-07/schema#", wu = "http://json-schema.org/draft-07/schema#", bu = "Core schema meta-schema", Eu = {
  schemaArray: {
    type: "array",
    minItems: 1,
    items: {
      $ref: "#"
    }
  },
  nonNegativeInteger: {
    type: "integer",
    minimum: 0
  },
  nonNegativeIntegerDefault0: {
    allOf: [
      {
        $ref: "#/definitions/nonNegativeInteger"
      },
      {
        default: 0
      }
    ]
  },
  simpleTypes: {
    enum: [
      "array",
      "boolean",
      "integer",
      "null",
      "number",
      "object",
      "string"
    ]
  },
  stringArray: {
    type: "array",
    items: {
      type: "string"
    },
    uniqueItems: !0,
    default: []
  }
}, Su = [
  "object",
  "boolean"
], Pu = {
  $id: {
    type: "string",
    format: "uri-reference"
  },
  $schema: {
    type: "string",
    format: "uri"
  },
  $ref: {
    type: "string",
    format: "uri-reference"
  },
  $comment: {
    type: "string"
  },
  title: {
    type: "string"
  },
  description: {
    type: "string"
  },
  default: !0,
  readOnly: {
    type: "boolean",
    default: !1
  },
  examples: {
    type: "array",
    items: !0
  },
  multipleOf: {
    type: "number",
    exclusiveMinimum: 0
  },
  maximum: {
    type: "number"
  },
  exclusiveMaximum: {
    type: "number"
  },
  minimum: {
    type: "number"
  },
  exclusiveMinimum: {
    type: "number"
  },
  maxLength: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minLength: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  pattern: {
    type: "string",
    format: "regex"
  },
  additionalItems: {
    $ref: "#"
  },
  items: {
    anyOf: [
      {
        $ref: "#"
      },
      {
        $ref: "#/definitions/schemaArray"
      }
    ],
    default: !0
  },
  maxItems: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minItems: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  uniqueItems: {
    type: "boolean",
    default: !1
  },
  contains: {
    $ref: "#"
  },
  maxProperties: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minProperties: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  required: {
    $ref: "#/definitions/stringArray"
  },
  additionalProperties: {
    $ref: "#"
  },
  definitions: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    default: {}
  },
  properties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    default: {}
  },
  patternProperties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    propertyNames: {
      format: "regex"
    },
    default: {}
  },
  dependencies: {
    type: "object",
    additionalProperties: {
      anyOf: [
        {
          $ref: "#"
        },
        {
          $ref: "#/definitions/stringArray"
        }
      ]
    }
  },
  propertyNames: {
    $ref: "#"
  },
  const: !0,
  enum: {
    type: "array",
    items: !0,
    minItems: 1,
    uniqueItems: !0
  },
  type: {
    anyOf: [
      {
        $ref: "#/definitions/simpleTypes"
      },
      {
        type: "array",
        items: {
          $ref: "#/definitions/simpleTypes"
        },
        minItems: 1,
        uniqueItems: !0
      }
    ]
  },
  format: {
    type: "string"
  },
  contentMediaType: {
    type: "string"
  },
  contentEncoding: {
    type: "string"
  },
  if: {
    $ref: "#"
  },
  then: {
    $ref: "#"
  },
  else: {
    $ref: "#"
  },
  allOf: {
    $ref: "#/definitions/schemaArray"
  },
  anyOf: {
    $ref: "#/definitions/schemaArray"
  },
  oneOf: {
    $ref: "#/definitions/schemaArray"
  },
  not: {
    $ref: "#"
  }
}, Nu = {
  $schema: vu,
  $id: wu,
  title: bu,
  definitions: Eu,
  type: Su,
  properties: Pu,
  default: !0
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.MissingRefError = t.ValidationError = t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = t.Ajv = void 0;
  const r = kn, n = gr, s = Br, a = Nu, i = ["/properties"], u = "http://json-schema.org/draft-07/schema";
  class d extends r.default {
    _addVocabularies() {
      super._addVocabularies(), n.default.forEach((v) => this.addVocabulary(v)), this.opts.discriminator && this.addKeyword(s.default);
    }
    _addDefaultMetaSchema() {
      if (super._addDefaultMetaSchema(), !this.opts.meta)
        return;
      const v = this.opts.$data ? this.$dataMetaSchema(a, i) : a;
      this.addMetaSchema(v, u, !1), this.refs["http://json-schema.org/schema"] = u;
    }
    defaultMeta() {
      return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(u) ? u : void 0);
    }
  }
  t.Ajv = d, e.exports = t = d, e.exports.Ajv = d, Object.defineProperty(t, "__esModule", { value: !0 }), t.default = d;
  var c = fe;
  Object.defineProperty(t, "KeywordCxt", { enumerable: !0, get: function() {
    return c.KeywordCxt;
  } });
  var h = H;
  Object.defineProperty(t, "_", { enumerable: !0, get: function() {
    return h._;
  } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
    return h.str;
  } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
    return h.stringify;
  } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
    return h.nil;
  } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
    return h.Name;
  } }), Object.defineProperty(t, "CodeGen", { enumerable: !0, get: function() {
    return h.CodeGen;
  } });
  var p = rt;
  Object.defineProperty(t, "ValidationError", { enumerable: !0, get: function() {
    return p.default;
  } });
  var N = Ue;
  Object.defineProperty(t, "MissingRefError", { enumerable: !0, get: function() {
    return N.default;
  } });
})(Bt, Bt.exports);
var Ru = Bt.exports;
const ku = /* @__PURE__ */ Rn(Ru);
class Wr {
  ruleResults = [];
  pw;
  minComplexity;
  constructor(t, r = 0) {
    this.pw = t, this.minComplexity = r;
  }
  validateRules(t) {
    t.forEach((r) => this.ruleResults.push(r.validate(this.pw)));
  }
  allRulesAreSatisfied() {
    const t = (n) => n.every((s) => s.isValid), r = this.ruleResults;
    return Wr.allResultsAreSync(this.ruleResults) ? t(this.ruleResults) : Promise.all(r).then(t);
  }
  calculateComplexity() {
    const { score: t } = Zr(this.pw);
    return t;
  }
  getResult() {
    const t = Zr(this.pw), r = t.score, n = r >= this.minComplexity, s = this.allRulesAreSatisfied();
    return {
      isValid: s instanceof Promise ? s.then((i) => i && n) : s && n,
      ruleResults: this.ruleResults,
      complexity: {
        actual: r,
        min: this.minComplexity,
        warning: t.feedback.warning
      }
    };
  }
  static allResultsAreSync(t) {
    return t.every((r) => !(r instanceof Promise));
  }
}
var Ss = { exports: {} };
(function(e) {
  (function() {
    var t = "input is invalid type", r = "finalize already called", n = typeof window == "object", s = n ? window : {};
    s.JS_SHA1_NO_WINDOW && (n = !1);
    var a = !n && typeof self == "object", i = !s.JS_SHA1_NO_NODE_JS && typeof xt == "object" && xt.versions && xt.versions.node;
    i ? s = Rs : a && (s = self);
    var u = !s.JS_SHA1_NO_COMMON_JS && !0 && e.exports, d = !s.JS_SHA1_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", c = "0123456789abcdef".split(""), h = [-2147483648, 8388608, 32768, 128], p = [24, 16, 8, 0], N = ["hex", "array", "digest", "arrayBuffer"], w = [], v = Array.isArray;
    (s.JS_SHA1_NO_NODE_JS || !v) && (v = function(m) {
      return Object.prototype.toString.call(m) === "[object Array]";
    });
    var b = ArrayBuffer.isView;
    d && (s.JS_SHA1_NO_ARRAY_BUFFER_IS_VIEW || !b) && (b = function(m) {
      return typeof m == "object" && m.buffer && m.buffer.constructor === ArrayBuffer;
    });
    var $ = function(m) {
      var S = typeof m;
      if (S === "string")
        return [m, !0];
      if (S !== "object" || m === null)
        throw new Error(t);
      if (d && m.constructor === ArrayBuffer)
        return [new Uint8Array(m), !1];
      if (!v(m) && !b(m))
        throw new Error(t);
      return [m, !1];
    }, f = function(m) {
      return function(S) {
        return new x(!0).update(S)[m]();
      };
    }, _ = function() {
      var m = f("hex");
      i && (m = I(m)), m.create = function() {
        return new x();
      }, m.update = function(P) {
        return m.create().update(P);
      };
      for (var S = 0; S < N.length; ++S) {
        var j = N[S];
        m[j] = f(j);
      }
      return m;
    }, I = function(m) {
      var S = Fs, j = ks.Buffer, P;
      j.from && !s.JS_SHA1_NO_BUFFER_FROM ? P = j.from : P = function(R) {
        return new j(R);
      };
      var T = function(R) {
        if (typeof R == "string")
          return S.createHash("sha1").update(R, "utf8").digest("hex");
        if (R == null)
          throw new Error(t);
        return R.constructor === ArrayBuffer && (R = new Uint8Array(R)), v(R) || b(R) || R.constructor === j ? S.createHash("sha1").update(P(R)).digest("hex") : m(R);
      };
      return T;
    }, M = function(m) {
      return function(S, j) {
        return new Y(S, !0).update(j)[m]();
      };
    }, F = function() {
      var m = M("hex");
      m.create = function(P) {
        return new Y(P);
      }, m.update = function(P, T) {
        return m.create(P).update(T);
      };
      for (var S = 0; S < N.length; ++S) {
        var j = N[S];
        m[j] = M(j);
      }
      return m;
    };
    function x(m) {
      m ? (w[0] = w[16] = w[1] = w[2] = w[3] = w[4] = w[5] = w[6] = w[7] = w[8] = w[9] = w[10] = w[11] = w[12] = w[13] = w[14] = w[15] = 0, this.blocks = w) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.h0 = 1732584193, this.h1 = 4023233417, this.h2 = 2562383102, this.h3 = 271733878, this.h4 = 3285377520, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0;
    }
    x.prototype.update = function(m) {
      if (this.finalized)
        throw new Error(r);
      var S = $(m);
      m = S[0];
      for (var j = S[1], P, T = 0, R, D = m.length || 0, O = this.blocks; T < D; ) {
        if (this.hashed && (this.hashed = !1, O[0] = this.block, this.block = O[16] = O[1] = O[2] = O[3] = O[4] = O[5] = O[6] = O[7] = O[8] = O[9] = O[10] = O[11] = O[12] = O[13] = O[14] = O[15] = 0), j)
          for (R = this.start; T < D && R < 64; ++T)
            P = m.charCodeAt(T), P < 128 ? O[R >>> 2] |= P << p[R++ & 3] : P < 2048 ? (O[R >>> 2] |= (192 | P >>> 6) << p[R++ & 3], O[R >>> 2] |= (128 | P & 63) << p[R++ & 3]) : P < 55296 || P >= 57344 ? (O[R >>> 2] |= (224 | P >>> 12) << p[R++ & 3], O[R >>> 2] |= (128 | P >>> 6 & 63) << p[R++ & 3], O[R >>> 2] |= (128 | P & 63) << p[R++ & 3]) : (P = 65536 + ((P & 1023) << 10 | m.charCodeAt(++T) & 1023), O[R >>> 2] |= (240 | P >>> 18) << p[R++ & 3], O[R >>> 2] |= (128 | P >>> 12 & 63) << p[R++ & 3], O[R >>> 2] |= (128 | P >>> 6 & 63) << p[R++ & 3], O[R >>> 2] |= (128 | P & 63) << p[R++ & 3]);
        else
          for (R = this.start; T < D && R < 64; ++T)
            O[R >>> 2] |= m[T] << p[R++ & 3];
        this.lastByteIndex = R, this.bytes += R - this.start, R >= 64 ? (this.block = O[16], this.start = R - 64, this.hash(), this.hashed = !0) : this.start = R;
      }
      return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
    }, x.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var m = this.blocks, S = this.lastByteIndex;
        m[16] = this.block, m[S >>> 2] |= h[S & 3], this.block = m[16], S >= 56 && (this.hashed || this.hash(), m[0] = this.block, m[16] = m[1] = m[2] = m[3] = m[4] = m[5] = m[6] = m[7] = m[8] = m[9] = m[10] = m[11] = m[12] = m[13] = m[14] = m[15] = 0), m[14] = this.hBytes << 3 | this.bytes >>> 29, m[15] = this.bytes << 3, this.hash();
      }
    }, x.prototype.hash = function() {
      var m = this.h0, S = this.h1, j = this.h2, P = this.h3, T = this.h4, R, D, O, G = this.blocks;
      for (D = 16; D < 80; ++D)
        O = G[D - 3] ^ G[D - 8] ^ G[D - 14] ^ G[D - 16], G[D] = O << 1 | O >>> 31;
      for (D = 0; D < 20; D += 5)
        R = S & j | ~S & P, O = m << 5 | m >>> 27, T = O + R + T + 1518500249 + G[D] << 0, S = S << 30 | S >>> 2, R = m & S | ~m & j, O = T << 5 | T >>> 27, P = O + R + P + 1518500249 + G[D + 1] << 0, m = m << 30 | m >>> 2, R = T & m | ~T & S, O = P << 5 | P >>> 27, j = O + R + j + 1518500249 + G[D + 2] << 0, T = T << 30 | T >>> 2, R = P & T | ~P & m, O = j << 5 | j >>> 27, S = O + R + S + 1518500249 + G[D + 3] << 0, P = P << 30 | P >>> 2, R = j & P | ~j & T, O = S << 5 | S >>> 27, m = O + R + m + 1518500249 + G[D + 4] << 0, j = j << 30 | j >>> 2;
      for (; D < 40; D += 5)
        R = S ^ j ^ P, O = m << 5 | m >>> 27, T = O + R + T + 1859775393 + G[D] << 0, S = S << 30 | S >>> 2, R = m ^ S ^ j, O = T << 5 | T >>> 27, P = O + R + P + 1859775393 + G[D + 1] << 0, m = m << 30 | m >>> 2, R = T ^ m ^ S, O = P << 5 | P >>> 27, j = O + R + j + 1859775393 + G[D + 2] << 0, T = T << 30 | T >>> 2, R = P ^ T ^ m, O = j << 5 | j >>> 27, S = O + R + S + 1859775393 + G[D + 3] << 0, P = P << 30 | P >>> 2, R = j ^ P ^ T, O = S << 5 | S >>> 27, m = O + R + m + 1859775393 + G[D + 4] << 0, j = j << 30 | j >>> 2;
      for (; D < 60; D += 5)
        R = S & j | S & P | j & P, O = m << 5 | m >>> 27, T = O + R + T - 1894007588 + G[D] << 0, S = S << 30 | S >>> 2, R = m & S | m & j | S & j, O = T << 5 | T >>> 27, P = O + R + P - 1894007588 + G[D + 1] << 0, m = m << 30 | m >>> 2, R = T & m | T & S | m & S, O = P << 5 | P >>> 27, j = O + R + j - 1894007588 + G[D + 2] << 0, T = T << 30 | T >>> 2, R = P & T | P & m | T & m, O = j << 5 | j >>> 27, S = O + R + S - 1894007588 + G[D + 3] << 0, P = P << 30 | P >>> 2, R = j & P | j & T | P & T, O = S << 5 | S >>> 27, m = O + R + m - 1894007588 + G[D + 4] << 0, j = j << 30 | j >>> 2;
      for (; D < 80; D += 5)
        R = S ^ j ^ P, O = m << 5 | m >>> 27, T = O + R + T - 899497514 + G[D] << 0, S = S << 30 | S >>> 2, R = m ^ S ^ j, O = T << 5 | T >>> 27, P = O + R + P - 899497514 + G[D + 1] << 0, m = m << 30 | m >>> 2, R = T ^ m ^ S, O = P << 5 | P >>> 27, j = O + R + j - 899497514 + G[D + 2] << 0, T = T << 30 | T >>> 2, R = P ^ T ^ m, O = j << 5 | j >>> 27, S = O + R + S - 899497514 + G[D + 3] << 0, P = P << 30 | P >>> 2, R = j ^ P ^ T, O = S << 5 | S >>> 27, m = O + R + m - 899497514 + G[D + 4] << 0, j = j << 30 | j >>> 2;
      this.h0 = this.h0 + m << 0, this.h1 = this.h1 + S << 0, this.h2 = this.h2 + j << 0, this.h3 = this.h3 + P << 0, this.h4 = this.h4 + T << 0;
    }, x.prototype.hex = function() {
      this.finalize();
      var m = this.h0, S = this.h1, j = this.h2, P = this.h3, T = this.h4;
      return c[m >>> 28 & 15] + c[m >>> 24 & 15] + c[m >>> 20 & 15] + c[m >>> 16 & 15] + c[m >>> 12 & 15] + c[m >>> 8 & 15] + c[m >>> 4 & 15] + c[m & 15] + c[S >>> 28 & 15] + c[S >>> 24 & 15] + c[S >>> 20 & 15] + c[S >>> 16 & 15] + c[S >>> 12 & 15] + c[S >>> 8 & 15] + c[S >>> 4 & 15] + c[S & 15] + c[j >>> 28 & 15] + c[j >>> 24 & 15] + c[j >>> 20 & 15] + c[j >>> 16 & 15] + c[j >>> 12 & 15] + c[j >>> 8 & 15] + c[j >>> 4 & 15] + c[j & 15] + c[P >>> 28 & 15] + c[P >>> 24 & 15] + c[P >>> 20 & 15] + c[P >>> 16 & 15] + c[P >>> 12 & 15] + c[P >>> 8 & 15] + c[P >>> 4 & 15] + c[P & 15] + c[T >>> 28 & 15] + c[T >>> 24 & 15] + c[T >>> 20 & 15] + c[T >>> 16 & 15] + c[T >>> 12 & 15] + c[T >>> 8 & 15] + c[T >>> 4 & 15] + c[T & 15];
    }, x.prototype.toString = x.prototype.hex, x.prototype.digest = function() {
      this.finalize();
      var m = this.h0, S = this.h1, j = this.h2, P = this.h3, T = this.h4;
      return [
        m >>> 24 & 255,
        m >>> 16 & 255,
        m >>> 8 & 255,
        m & 255,
        S >>> 24 & 255,
        S >>> 16 & 255,
        S >>> 8 & 255,
        S & 255,
        j >>> 24 & 255,
        j >>> 16 & 255,
        j >>> 8 & 255,
        j & 255,
        P >>> 24 & 255,
        P >>> 16 & 255,
        P >>> 8 & 255,
        P & 255,
        T >>> 24 & 255,
        T >>> 16 & 255,
        T >>> 8 & 255,
        T & 255
      ];
    }, x.prototype.array = x.prototype.digest, x.prototype.arrayBuffer = function() {
      this.finalize();
      var m = new ArrayBuffer(20), S = new DataView(m);
      return S.setUint32(0, this.h0), S.setUint32(4, this.h1), S.setUint32(8, this.h2), S.setUint32(12, this.h3), S.setUint32(16, this.h4), m;
    };
    function Y(m, S) {
      var j, P = $(m);
      if (m = P[0], P[1]) {
        var T = [], R = m.length, D = 0, O;
        for (j = 0; j < R; ++j)
          O = m.charCodeAt(j), O < 128 ? T[D++] = O : O < 2048 ? (T[D++] = 192 | O >>> 6, T[D++] = 128 | O & 63) : O < 55296 || O >= 57344 ? (T[D++] = 224 | O >>> 12, T[D++] = 128 | O >>> 6 & 63, T[D++] = 128 | O & 63) : (O = 65536 + ((O & 1023) << 10 | m.charCodeAt(++j) & 1023), T[D++] = 240 | O >>> 18, T[D++] = 128 | O >>> 12 & 63, T[D++] = 128 | O >>> 6 & 63, T[D++] = 128 | O & 63);
        m = T;
      }
      m.length > 64 && (m = new x(!0).update(m).array());
      var G = [], Ie = [];
      for (j = 0; j < 64; ++j) {
        var Pe = m[j] || 0;
        G[j] = 92 ^ Pe, Ie[j] = 54 ^ Pe;
      }
      x.call(this, S), this.update(Ie), this.oKeyPad = G, this.inner = !0, this.sharedMemory = S;
    }
    Y.prototype = new x(), Y.prototype.finalize = function() {
      if (x.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var m = this.array();
        x.call(this, this.sharedMemory), this.update(this.oKeyPad), this.update(m), x.prototype.finalize.call(this);
      }
    };
    var se = _();
    se.sha1 = se, se.sha1.hmac = F(), u ? e.exports = se : s.sha1 = se;
  })();
})(Ss);
var Ou = Ss.exports;
const ju = /* @__PURE__ */ Rn(Ou), Tu = ju;
class Iu {
  hibpAxios;
  constructor() {
    this.hibpAxios = As.create({
      baseURL: "https://api.pwnedpasswords.com"
    });
  }
  async isPasswordLeaked(t) {
    const r = Tu.hex(t).toString(), n = r.slice(0, 5), s = r.slice(5), i = (await this.hibpAxios.get(`/range/${n}`)).data.split(`
`);
    for (const u of i)
      if (u.startsWith(s.toUpperCase()))
        return !0;
    return !1;
  }
}
class Cu extends Nn {
  async validate(t) {
    return {
      isValid: !await new Iu().isPasswordLeaked(t),
      ruleType: he.hibp,
      ...this.config
    };
  }
}
const Rt = (e, t, r) => {
  const n = [];
  let s = "", a = "", i = e.length;
  for (const u of e)
    r(u, s) ? (a += u, i === 1 && a.length > t && n.push(a)) : (a.length > t && n.push(a), a = u), s = u, --i;
  return n;
}, Xr = (e, t, r) => {
  const n = r.indexOf(t);
  return r.indexOf(e) - 1 === n && n !== -1;
}, Au = (e, t) => Rt(e, t, (r, n) => Xr(r, n, "0123456789")), Mu = (e, t) => Rt(e, t, (r, n) => Xr(r, n, "abcdefghijklmnopqrstuvwxyz")), Fu = (e, t) => Rt(e, t, (r, n) => {
  const a = [
    "^1234567890ß´",
    "qwertzuiopü+",
    "QWERTZUIOPÜ*",
    "asdfghjklöä#",
    "ASDFGHJKLÖÄ'",
    "<yxcvbnm,.-",
    ">YXCVBNM;:_",
    '°!"§$%&/()=?`'
  ].find((i) => i.includes(r));
  return a ? Xr(r, n, a) : !1;
}), Du = (e, t) => Rt(e, t, (r, n) => r === n);
class Vu extends nr {
  validate(t) {
    const { sequences: r } = this.config, n = this.config.maxLength ?? 3, s = r.map((u) => ({
      type: u,
      found: this.findSequences(u, t, n)
    })), a = !s.some((u) => u.found.length > 0), i = (({ sequences: u, ...d }) => d)(
      this.config
    );
    return {
      ruleType: he.sequence,
      sequences: s,
      isValid: a,
      ...i,
      maxLength: n
    };
  }
  findSequences(t, r, n) {
    switch (t) {
      case st.repeat:
        return Du(r, n);
      case st.keyboard:
        return Fu(r, n);
      case st.number:
        return Au(r, n);
      case st.alphabet:
        return Mu(r, n);
    }
  }
}
const qu = (e, t, r) => {
  const n = t ?? [];
  n.push("g");
  const a = [...new Set(n)].join("");
  return RegExp(e, a);
};
class zu extends nr {
  validate(t) {
    const { max: r, pattern: n, flags: s } = this.config, a = this.config.min === void 0 && r === void 0 ? 1 : this.config.min, i = qu(n, s), u = t.match(i)?.length ?? 0, d = Os(u, { min: a, max: r });
    return {
      isValid: d === !0,
      failingBoundary: d === !0 ? void 0 : d,
      ruleType: he.regex,
      matches: u,
      ...this.config,
      min: a
    };
  }
}
const Uu = (e) => {
  switch (e.ruleType) {
    case he.length:
      return new Cs(e);
    case he.charPool:
      return new Is(e);
    case he.char:
      return new Ts(e);
    case he.regex:
      return new zu(e);
    case he.blocklist:
      return new js(e);
    case he.hibp:
      return new Cu(e);
    case he.sequence:
      return new Vu(e);
  }
  throw new Error(`Error factoring rule ${e.ruleType}`);
}, xu = "http://json-schema.org/draft-07/schema#", Ku = !1, Lu = {
  AnyRuleDeclaration: {
    anyOf: [
      {
        $ref: "#/definitions/LengthRuleDeclaration"
      },
      {
        $ref: "#/definitions/HibpRuleDeclaration"
      },
      {
        $ref: "#/definitions/BlocklistRuleDeclaration"
      },
      {
        $ref: "#/definitions/SequenceRuleDeclaration"
      },
      {
        $ref: "#/definitions/CharRuleDeclaration"
      },
      {
        $ref: "#/definitions/CharPoolRuleDeclaration"
      },
      {
        $ref: "#/definitions/RegexRuleDeclaration"
      }
    ]
  },
  BlocklistRuleDeclaration: {
    additionalProperties: !1,
    properties: {
      blocklist: {
        items: {
          type: "string"
        },
        type: "array"
      },
      identifier: {
        type: "string"
      },
      ruleType: {
        const: "blocklist",
        type: "string"
      },
      substringMatch: {
        type: "boolean"
      }
    },
    required: [
      "blocklist",
      "ruleType",
      "substringMatch"
    ],
    type: "object"
  },
  CharPoolRuleDeclaration: {
    additionalProperties: !1,
    properties: {
      charPools: {
        items: {
          enum: [
            "lowercase",
            "nonAscii",
            "numbers",
            "special",
            "uppercase"
          ],
          type: "string"
        },
        type: "array"
      },
      identifier: {
        type: "string"
      },
      max: {
        type: "number"
      },
      min: {
        type: "number"
      },
      ruleType: {
        const: "charPool",
        type: "string"
      }
    },
    required: [
      "charPools",
      "ruleType"
    ],
    type: "object"
  },
  CharRuleDeclaration: {
    additionalProperties: !1,
    properties: {
      chars: {
        type: "string"
      },
      identifier: {
        type: "string"
      },
      max: {
        type: "number"
      },
      min: {
        type: "number"
      },
      ruleType: {
        const: "char",
        type: "string"
      }
    },
    required: [
      "chars",
      "ruleType"
    ],
    type: "object"
  },
  HibpRuleDeclaration: {
    additionalProperties: !1,
    properties: {
      identifier: {
        type: "string"
      },
      ruleType: {
        const: "hibp",
        type: "string"
      }
    },
    required: [
      "ruleType"
    ],
    type: "object"
  },
  LengthRuleDeclaration: {
    additionalProperties: !1,
    properties: {
      identifier: {
        type: "string"
      },
      max: {
        type: "number"
      },
      min: {
        type: "number"
      },
      ruleType: {
        const: "length",
        type: "string"
      }
    },
    required: [
      "ruleType"
    ],
    type: "object"
  },
  RegexFlags: {
    enum: [
      "d",
      "g",
      "i",
      "m",
      "s",
      "u",
      "y"
    ],
    type: "string"
  },
  RegexRuleDeclaration: {
    additionalProperties: !1,
    properties: {
      flags: {
        items: {
          $ref: "#/definitions/RegexFlags"
        },
        type: "array"
      },
      identifier: {
        type: "string"
      },
      max: {
        type: "number"
      },
      min: {
        type: "number"
      },
      pattern: {
        type: "string"
      },
      ruleType: {
        const: "regex",
        type: "string"
      },
      translationKey: {
        type: "string"
      }
    },
    required: [
      "pattern",
      "ruleType"
    ],
    type: "object"
  },
  SequenceRuleDeclaration: {
    additionalProperties: !1,
    properties: {
      identifier: {
        type: "string"
      },
      maxLength: {
        type: "number"
      },
      ruleType: {
        const: "sequence",
        type: "string"
      },
      sequences: {
        items: {
          $ref: "#/definitions/SequenceType"
        },
        type: "array"
      }
    },
    required: [
      "ruleType",
      "sequences"
    ],
    type: "object"
  },
  SequenceType: {
    enum: [
      "alphabet",
      "keyboard",
      "number",
      "repeat"
    ],
    type: "string"
  }
}, Hu = {
  minComplexity: {
    enum: [
      0,
      1,
      2,
      3,
      4
    ],
    type: "number"
  },
  rules: {
    items: {
      $ref: "#/definitions/AnyRuleDeclaration"
    },
    type: "array"
  }
}, Gu = [
  "rules"
], Ju = "object", Bu = {
  $schema: xu,
  additionalProperties: Ku,
  definitions: Lu,
  properties: Hu,
  required: Gu,
  type: Ju
};
class Ps {
  rules;
  minComplexity;
  constructor(t, r = 0) {
    this.rules = t, this.minComplexity = r;
  }
  static fromDeclaration(t) {
    const r = t.rules.map(Uu);
    return new Ps(r, t.minComplexity);
  }
  static async fromDeclarationRemote(t, r) {
    const n = await new Ms(t).loadPolicy(r);
    return this.fromDeclaration(n);
  }
  validate(t) {
    const r = this.rules.filter((a) => a instanceof nr), n = this.rules.filter((a) => a instanceof Nn), s = new Wr(t, this.minComplexity);
    return s.validateRules(r), s.allRulesAreSatisfied() && s.validateRules(n), s.getResult();
  }
  static assertValidDeclaration(t) {
    const r = new ku().compile(Bu);
    if (r(t), r.errors) {
      const n = r.errors.map((s) => s.message);
      throw new Error(n.toString());
    }
  }
}
export {
  Ps as Policy
};
